import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./style.css";
import "./pos.css";
import jsPDF from "jspdf";
import { getAuthUser, logout} from "./auth";

const LOCAL_API_URL =
  process.env.REACT_APP_LOCAL_API_URL || "http://localhost:7000";

function POSPage() {
  const [manualMode, setManualMode] = useState(null);
  const [manualPrice, setManualPrice] = useState("");
  const [cart, setCart] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [error, setError] = useState("");
  const [showZConfirm, setShowZConfirm] = useState(false);
  const [cashPaid, setCashPaid] = useState(0);
  const [cardPaid, setCardPaid] = useState(0);
  const [holdMessage, setHoldMessage] = useState(null);
  const [inquiryMode, setInquiryMode] = useState(false);
  const [inquiryItem, setInquiryItem] = useState(null);
  const [showCoffeeOptions, setShowCoffeeOptions] = useState(false);
  const [lastSale, setLastSale] = useState(null);
  const [ageVerifiedThisSale, setAgeVerifiedThisSale] = useState(false);
  const [agePromptProduct, setAgePromptProduct] = useState(null);
 const [shopSettings, setShopSettings] = useState(() => {
  try {
    const cached = localStorage.getItem("shop_config_cache");

    if (!cached) {
      return null;
    }

    const parsed = JSON.parse(cached);

    return parsed && typeof parsed === "object"
      ? parsed
      : null;
  } catch {
    return null;
  }
});
  const [licenseStatus, setLicenseStatus] = useState(null);
  const [licenseError, setLicenseError] = useState("");
  const [shopId, setShopId] = useState(() => {
  try {
    const cached = JSON.parse(
      localStorage.getItem("shop_config_cache") || "null"
    );

    const cachedShopId = Number(
      cached?.shop_id || cached?.shopId || 0
    );

    return cachedShopId > 0
      ? cachedShopId
      : null;
  } catch {
    return null;
  }
});
  const [authUser, setAuthUser] = useState(null);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [saleCompleted, setSaleCompleted] = useState(false);
  const [refundMode, setRefundMode] = useState(false);
  const [appVersion, setAppVersion] = useState("");

  const [multiBuyPromotions, setMultiBuyPromotions] = useState([]);
const [multiBuyProducts, setMultiBuyProducts] = useState([]);

const [showDeviceSale, setShowDeviceSale] = useState(false);
const [deviceStep, setDeviceStep] = useState(1);
const [devicePrice, setDevicePrice] = useState("");
const [deviceDescription, setDeviceDescription] = useState("");
const [deviceGuarantee, setDeviceGuarantee] = useState(null);

const [showMarginVatSale, setShowMarginVatSale] = useState(false);
const [marginVatStep, setMarginVatStep] = useState(1);
const [marginVatPrice, setMarginVatPrice] = useState("");
const [marginVatDescription, setMarginVatDescription] = useState("");
const [marginVatGuarantee, setMarginVatGuarantee] = useState(null);

  const [syncStatus, setSyncStatus] = useState({
    online: false,
    pendingSales: 0,
    message: "Checking sync status...",
  });

  const marginVatWarrantyOptions = [
  {
    value: 1,
    unit: "week",
    label: "1 Week",
  },
  {
    value: 2,
    unit: "week",
    label: "2 Weeks",
  },
  {
    value: 3,
    unit: "week",
    label: "3 Weeks",
  },
  {
    value: 4,
    unit: "week",
    label: "4 Weeks",
  },
  {
    value: 1,
    unit: "month",
    label: "1 Month",
  },
  {
    value: 3,
    unit: "month",
    label: "3 Months",
  },
  {
    value: 6,
    unit: "month",
    label: "6 Months",
  },
  {
    value: 12,
    unit: "month",
    label: "12 Months",
  },
];

  const scannerRef = useRef(null);
  const navigate = useNavigate();

  const vatRates = {
    A: 0,
    B: 23,
    C: 13.5,
    D: 5,
    E: 9,
  };

const openVapeManualMode = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  const vapeAgeCheckItem = {
    id: `age-check-vape-${Date.now()}`,
    name: "Vape Item",
    price: 0,
    cost_price: 0,
    qty: 1,
    vat_code: "B",
    category: "vape",
    age_restricted: true,
    is_manual: true,
    pending_manual_mode: "vape",
  };

  // If age already verified in this sale, open amount modal directly
  if (ageVerifiedThisSale) {
    setManualPrice("");
    setManualMode("vape");
    setHoldMessage(null);
    setError("");
    focusScanner();
    return;
  }

  // Force existing age popup to open
  setAgePromptProduct(vapeAgeCheckItem);
  setManualPrice("");
  setManualMode(null);
  setHoldMessage(null);
  setError("");
};

const openNicotinePouchManualMode = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  const nicotinePouchAgeCheckItem = {
    id: `age-check-nicotine-pouch-${Date.now()}`,
    name: "Nicotine Pouch",
    price: 0,
    cost_price: 0,
    qty: 1,
    vat_code: "B",
    category: "nicotine-pouch",
    age_restricted: true,
    is_manual: true,
    pending_manual_mode: "nicotine-pouch",
  };

  // If age already approved in this sale, open amount modal directly
  if (ageVerifiedThisSale) {
    setManualPrice("");
    setManualMode("nicotine-pouch");
    setHoldMessage(null);
    setError("");
    focusScanner();
    return;
  }

  // Force existing age popup
  setAgePromptProduct(nicotinePouchAgeCheckItem);
  setManualPrice("");
  setManualMode(null);
  setHoldMessage(null);
  setError("");
};

const openLiquidManualMode = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  const liquidAgeCheckItem = {
    id: `age-check-liquid-${Date.now()}`,
    name: "E-Liquid",
    price: 0,
    cost_price: 0,
    qty: 1,
    vat_code: "B",
    category: "e-liquid",
    age_restricted: true,
    is_manual: true,
    pending_manual_mode: "e-liquid",
  };

  if (ageVerifiedThisSale) {
    setManualPrice("");
    setManualMode("e-liquid");
    setHoldMessage(null);
    setError("");
    focusScanner();
    return;
  }

  setAgePromptProduct(liquidAgeCheckItem);
  setManualPrice("");
  setManualMode(null);
  setHoldMessage(null);
  setError("");
};

const openVapeAccessoriesManualMode = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  const vapeAccessoriesAgeCheckItem = {
    id: `age-check-vape-accessories-${Date.now()}`,
    name: "Vape Accessories",
    price: 0,
    cost_price: 0,
    qty: 1,
    vat_code: "B",
    category: "vape-accessories",
    age_restricted: true,
    is_manual: true,
    pending_manual_mode: "vape-accessories",
  };

  if (ageVerifiedThisSale) {
    setManualPrice("");
    setManualMode("vape-accessories");
    setHoldMessage(null);
    setError("");
    focusScanner();
    return;
  }

  setAgePromptProduct(vapeAccessoriesAgeCheckItem);
  setManualPrice("");
  setManualMode(null);
  setHoldMessage(null);
  setError("");
};

const openPodsManualMode = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  const podsAgeCheckItem = {
    id: `age-check-pods-${Date.now()}`,
    name: "Pods",
    price: 0,
    cost_price: 0,
    qty: 1,
    vat_code: "B",
    category: "pods",
    age_restricted: true,
    is_manual: true,
    pending_manual_mode: "pods",
  };

  if (ageVerifiedThisSale) {
    setManualPrice("");
    setManualMode("pods");
    setHoldMessage(null);
    setError("");
    focusScanner();
    return;
  }

  setAgePromptProduct(podsAgeCheckItem);
  setManualPrice("");
  setManualMode(null);
  setHoldMessage(null);
  setError("");
};

const openPhoneAccessoriesManualMode = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  setManualPrice("");
  setManualMode("phone-accessories");
  setHoldMessage(null);
  setError("");
  focusScanner();
};

const openPrintScanServiceManualMode = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  setManualPrice("");
  setManualMode("print-scan-service");
  setHoldMessage(null);
  setError("");
  focusScanner();
};

const openRepairServiceManualMode = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  setManualPrice("");
  setManualMode("repair-service");
  setHoldMessage(null);
  setError("");
  focusScanner();
};

  const getCostPrice = (item) => {
  return Number(
    item?.cost_price ??
      item?.costPrice ??
      item?.cost ??
      item?.buying_price ??
      item?.buyingPrice ??
      0
  );
};

  const cacheShopConfig = (config) => {
    try {
      localStorage.setItem("shop_config_cache", JSON.stringify(config || {}));
    } catch {
      // Ignore cache errors
    }
  };

  const focusScanner = () => {
    setTimeout(() => {
      scannerRef.current?.focus();
    }, 100);
  };

  const resetAgeCheckForNewSale = () => {
    setAgeVerifiedThisSale(false);
    setAgePromptProduct(null);
  };

  const resetSale = () => {
    setCart([]);
    setBarcode("");
    setManualPrice("");
    setManualMode(null);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
    setError("");
    focusScanner();
  };

 const getMultiBuyCalculation = () => {
  const adjustedItems = cart.map((item) => ({
    ...item,

    effective_price: Number(
      item.price || 0
    ),

    promo_applied: false,
    promotion_id: null,
    promotion_name: null,

    original_price: Number(
      item.price || 0
    ),

    discount_amount: 0,
  }));

  let promotionSaving = 0;

  multiBuyPromotions.forEach(
    (promotion) => {
      if (
        !promotion ||
        Number(promotion.active) !== 1
      ) {
        return;
      }

      const promotionId = Number(
        promotion.id
      );

      const requiredQty = Number(
        promotion.required_qty || 0
      );

      const bundlePrice = Number(
        promotion.bundle_price || 0
      );

      if (
        requiredQty < 2 ||
        bundlePrice <= 0
      ) {
        return;
      }

      // Example:
      // 2 for €14 = €7 each
      const promoUnitPrice =
        bundlePrice / requiredQty;

      const eligibleProductIds =
        new Set(
          multiBuyProducts
            .filter(
              (product) =>
                Number(
                  product.promotion_id
                ) === promotionId
            )
            .map((product) =>
              String(
                product.product_id
              )
            )
        );

      // ==================================
      // COUNT ALL ELIGIBLE CART QUANTITY
      // ==================================

      let eligibleQty = 0;

      adjustedItems.forEach(
        (item) => {
          if (
            item.is_refund ||
            item.is_manual
          ) {
            return;
          }

          const productId =
            String(
              item.product_id ??
                item.id ??
                ""
            );

          if (
            !eligibleProductIds.has(
              productId
            )
          ) {
            return;
          }

          eligibleQty += Number(
            item.qty || 0
          );
        }
      );

      // Promotion only starts when
      // minimum quantity is reached.
      if (
        eligibleQty < requiredQty
      ) {
        return;
      }

      // ==================================
      // APPLY PROMO PRICE TO ALL
      // ELIGIBLE ITEMS
      // ==================================

      adjustedItems.forEach(
        (item) => {
          if (
            item.is_refund ||
            item.is_manual
          ) {
            return;
          }

          const productId =
            String(
              item.product_id ??
                item.id ??
                ""
            );

          if (
            !eligibleProductIds.has(
              productId
            )
          ) {
            return;
          }

          const qty = Number(
            item.qty || 0
          );

          const originalPrice =
            Number(
              item.price || 0
            );

          /*
            Never make an item MORE
            expensive because of a promotion.

            Example:
            promo unit price = €7
            normal item price = €6

            Keep €6.
          */
          const effectivePrice =
            Math.min(
              originalPrice,
              promoUnitPrice
            );

          const discountPerItem =
            Math.max(
              0,
              originalPrice -
                effectivePrice
            );

          const itemSaving =
            discountPerItem * qty;

          promotionSaving +=
            itemSaving;

          item.original_price =
            originalPrice;

          item.effective_price =
            effectivePrice;

          item.discount_amount =
            discountPerItem;

          item.promo_applied =
            discountPerItem > 0;

          if (
            discountPerItem > 0
          ) {
            item.promotion_id =
              promotionId;

            item.promotion_name =
              promotion.name ||
              "Multi-Buy Promotion";
          }
        }
      );
    }
  );

  // ==================================
  // FINAL TOTAL
  // ==================================

  const finalTotal =
    adjustedItems.reduce(
      (sum, item) => {
        const price = Number(
          item.effective_price ??
            item.price ??
            0
        );

        const drs = Number(
          item.drs_amount ||
            item.drsAmount ||
            0
        );

        const qty = Number(
          item.qty || 0
        );

        return (
          sum +
          (price + drs) * qty
        );
      },
      0
    );

  return {
    items: adjustedItems,

    total: Number(
      finalTotal.toFixed(2)
    ),

    saving: Number(
      promotionSaving.toFixed(2)
    ),
  };
};

const multiBuyCalculation =
  getMultiBuyCalculation();

const pricedCart =
  multiBuyCalculation.items;

const multiBuySaving =
  Number(multiBuyCalculation.saving || 0);

const total =
  Number(multiBuyCalculation.total || 0);

// Normal shelf-price subtotal before multi-buy discount
const originalSubtotal = cart.reduce(
  (sum, item) => {
    const price = Number(item.price || 0);
    const drs = Number(
      item.drs_amount ||
      item.drsAmount ||
      0
    );
    const qty = Number(item.qty || 0);

    return sum + (price + drs) * qty;
  },
  0
);

console.log("MULTI BUY DEBUG", {
  cart: cart.map((item) => ({
    id: item.id,
    product_id: item.product_id,
    name: item.name,
    barcode: item.barcode,
    qty: item.qty,
    price: item.price,
  })),
  multiBuyPromotions,
  multiBuyProducts,
});

  useEffect(() => {
    let mounted = true;

    const fetchLocalShopConfig = async () => {
      try {
        const res = await axios.get(`${LOCAL_API_URL}/local-config`, {
          timeout: 1500,
        });

        if (!mounted) return;

        console.log("POS local shop config:", res.data);

        setShopSettings(res.data || {});
        setShopId(Number(res.data?.shop_id || 1));
        cacheShopConfig(res.data || {});
      } catch (err) {
        console.error("Local shop config load error:", err.message);
      }
    };

    fetchLocalShopConfig();

    const interval = setInterval(fetchLocalShopConfig, 10000);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const user = getAuthUser();
    setAuthUser(user);
  }, []);

  useEffect(() => {
  const loadAppVersion = async () => {
    try {
      if (!window.electron?.ipcRenderer?.invoke) {
        return;
      }

      const version = await window.electron.ipcRenderer.invoke(
        "get-app-version"
      );

      setAppVersion(version);
    } catch (err) {
      console.error("Could not load app version:", err);
    }
  };

  loadAppVersion();
}, []);

  useEffect(() => {
    fetchSyncStatus();

    const interval = setInterval(() => {
      fetchSyncStatus();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
  let retryTimer = null;

  const checkLicense = async () => {
    try {
      const res = await axios.get(
        `${LOCAL_API_URL}/license/check`,
        {
          timeout: 6000,
        }
      );

      console.log(
        "POS LOCAL LICENSE STATUS:",
        res.data
      );

      clearTimeout(retryTimer);
      retryTimer = null;

      setLicenseStatus(res.data);
      setLicenseError("");
    } catch (err) {
      const responseData = err.response?.data;

      const confirmedInvalid =
        err.response?.status === 403 &&
        responseData?.valid === false;

      console.error(
        "POS licence check error:",
        responseData || err.message
      );

      if (confirmedInvalid) {
        setLicenseStatus({
          ...responseData,
          valid: false,
        });

        setLicenseError(
          responseData?.reason ||
            "Licence is not valid"
        );

        return;
      }

      /*
        Temporary timeout, network failure or local-server
        error must not invalidate a previously valid licence.
      */
      setLicenseStatus((previousStatus) => {
        if (previousStatus?.valid === true) {
          return {
            ...previousStatus,
            offline_mode: true,
          };
        }

        return previousStatus;
      });

      setLicenseError(
        "Licence check temporarily unavailable. Retrying..."
      );

      clearTimeout(retryTimer);
      retryTimer = setTimeout(
        checkLicense,
        10000
      );
    }
  };

  checkLicense();

  const interval = setInterval(
    checkLicense,
    60000
  );

  return () => {
    clearInterval(interval);
    clearTimeout(retryTimer);
  };
}, []);

useEffect(() => {
  const interval = setInterval(() => {
    // Do NOT steal focus while a popup/modal
    // requires keyboard input.
const shouldPauseScannerFocus =
  showDeviceSale ||
  showMarginVatSale ||
  manualMode ||
  agePromptProduct ||
  showCoffeeOptions ||
  showZConfirm;

    if (shouldPauseScannerFocus) {
      return;
    }

    if (document.activeElement !== scannerRef.current) {
      scannerRef.current?.focus();
    }
  }, 1000);

  return () => clearInterval(interval);
}, [
  showDeviceSale,
  showMarginVatSale,
  manualMode,
  agePromptProduct,
  showCoffeeOptions,
  showZConfirm,
]);


useEffect(() => {
  const loadMultiBuyPromotions = async () => {
    if (!shopId) return;

    try {
      const res = await axios.get(
        `${LOCAL_API_URL}/multi-buy-promotions`,
        {
          params: {
            shop_id: shopId,
          },
          timeout: 3000,
        }
      );

      console.log("POS MULTI BUY DATA:", res.data);

      setMultiBuyPromotions(
        Array.isArray(res.data?.promotions)
          ? res.data.promotions
          : []
      );

      setMultiBuyProducts(
        Array.isArray(res.data?.products)
          ? res.data.products
          : []
      );
    } catch (err) {
      console.error(
        "Multi-buy promotion load error:",
        err.response?.data || err.message
      );
    }
  };

  loadMultiBuyPromotions();

  const interval = setInterval(
    loadMultiBuyPromotions,
    30000
  );

  return () => clearInterval(interval);
}, [shopId]);

  const fetchSyncStatus = async () => {
    try {
      const res = await axios.get(`${LOCAL_API_URL}/sync/status`);

      setSyncStatus(res.data);
    } catch (err) {
      setSyncStatus({
        online: false,
        pendingSales: 0,
        message: "Local till server not responding",
      });
    }
  };

  const handleLogout = () => {
    logout();
    resetSale();
    navigate("/login");
  };

  const addSurcharge = () => {
    const surchargeItem = {
      id: `surcharge-50c-${Date.now()}-${Math.random()}`,
      name: "Service Surcharge",
      price: 0.5,
      qty: 1,
      category: "surcharge",
      vat_code: "A",
      container_size_ml: null,
      is_drs: false,
      drs_amount: 0,
    };

    if (saleCompleted) {
      setCart([surchargeItem]);
      setCashPaid(0);
      setCardPaid(0);
      setHoldMessage(null);
      setError("");
      setSaleCompleted(false);
      resetAgeCheckForNewSale();
    } else {
      setCart((prev) => [...prev, surchargeItem]);
    }

    setError("");
    focusScanner();
  };

  const isAgeRestrictedProduct = (product) => {
    const category = String(product.category || "").trim().toLowerCase();

    return category === "tobacco" || category === "lottery" || category === "lottery-payout";
  };

  const handleAgeCheckBeforeAdd = (product) => {
    if (!isAgeRestrictedProduct(product)) {
      return false;
    }

    if (product.category === "lottery-payout") {
      setAgePromptProduct(product);
      return true;
    }

    if (ageVerifiedThisSale) {
      return false;
    }

    setAgePromptProduct(product);
    return true;
  };

const approveAgeCheck = () => {
  if (!agePromptProduct) return;

  setAgeVerifiedThisSale(true);

  // ✅ Special case for Vape manual button
  // Age approved first, then open amount modal
  if (agePromptProduct.pending_manual_mode) {
  const mode = agePromptProduct.pending_manual_mode;

  setAgePromptProduct(null);
  setManualPrice("");
  setManualMode(mode);
  setHoldMessage(null);
  setError("");
  focusScanner();

  return;
}

  const product = agePromptProduct;

  setCart((prev) => {
    const existing = prev.find((item) => item.id === product.id);

    if (existing) {
      return prev.map((item) =>
        item.id === product.id ? { ...item, qty: item.qty + 1 } : item
      );
    }

    return [
      ...prev,
      {
        ...product,
        qty: 1,
        cost_price: getCostPrice(product),
        category: product.category || "uncategorized",
        vat_code: product.vat_code || "A",
        container_size_ml: product.container_size_ml || null,
        is_drs: product.is_drs || false,
        drs_amount: Number(product.drs_amount || 0),
      },
    ];
  });

  setAgePromptProduct(null);
  setBarcode("");
  setError("");
  focusScanner();
};

  const refuseAgeCheck = () => {
    setAgePromptProduct(null);
    setError("❌ Age restricted product refused");

    setTimeout(() => {
      setError("");
    }, 900);

    setBarcode("");
    focusScanner();
  };

  const playErrorBeep = () => {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      const audioCtx = new AudioContext();

      const gainNode = audioCtx.createGain();
      gainNode.connect(audioCtx.destination);
      gainNode.gain.setValueAtTime(0.35, audioCtx.currentTime);

      const beep1 = audioCtx.createOscillator();
      beep1.type = "sawtooth";
      beep1.frequency.setValueAtTime(220, audioCtx.currentTime);
      beep1.connect(gainNode);
      beep1.start(audioCtx.currentTime);
      beep1.stop(audioCtx.currentTime + 0.16);

      const beep2 = audioCtx.createOscillator();
      beep2.type = "square";
      beep2.frequency.setValueAtTime(1200, audioCtx.currentTime + 0.18);
      beep2.connect(gainNode);
      beep2.start(audioCtx.currentTime + 0.18);
      beep2.stop(audioCtx.currentTime + 0.34);

      setTimeout(() => {
        audioCtx.close();
      }, 450);
    } catch (audioError) {
      console.log("Error beep failed:", audioError);
    }
  };

  /* const handleCardButton = (amount) => {
    const safeAmount = Number(amount || 0);

    const newCard = cardPaid + safeAmount;
    setCardPaid(newCard);

    const totalPaid = cashPaid + newCard;
    const remaining = total - totalPaid;

    if (remaining > 0) return;

    setHoldMessage({
      type: "CHANGE",
      value: Math.abs(remaining),
    });

    checkout({
      cash: cashPaid,
      card: newCard,
    });
  };

  const handleCashButton = (amount) => {
    const safeAmount = Number(amount || 0);

    const newCash = cashPaid + safeAmount;
    setCashPaid(newCash);

    const totalPaid = newCash + cardPaid;
    const remaining = total - totalPaid;

    if (remaining > 0) return;

    setHoldMessage({
      type: "CHANGE",
      value: Math.abs(remaining),
    });

    checkout({
      cash: newCash,
      card: cardPaid,
    });
  }; */

  const handleCardButton = (amount) => {
  const isRefundSale =
    Number(total || 0) < 0 || cart.some((item) => item.is_refund);

  if (isRefundSale) {
    const refundAmount = Math.abs(Number(total || 0));

    if (refundAmount <= 0) {
      setError("Refund amount must be more than 0");
      return;
    }

    setCashPaid(0);
    setCardPaid(refundAmount);

    setHoldMessage(`Card refund: €${refundAmount.toFixed(2)}`);

    checkout({
      cash: 0,
      card: refundAmount,
    });

    return;
  }

  const safeAmount = Number(amount || 0);

  const newCard = cardPaid + safeAmount;
  setCardPaid(newCard);

  const totalPaid = cashPaid + newCard;
  const remaining = total - totalPaid;

  if (remaining > 0) return;

  setHoldMessage({
    type: "CHANGE",
    value: Math.abs(remaining),
  });

  checkout({
    cash: cashPaid,
    card: newCard,
  });
};

const handleCashButton = (amount) => {
  const isRefundSale =
    Number(total || 0) < 0 || cart.some((item) => item.is_refund);

  if (isRefundSale) {
    const refundAmount = Math.abs(Number(total || 0));

    if (refundAmount <= 0) {
      setError("Refund amount must be more than 0");
      return;
    }

    setCashPaid(refundAmount);
    setCardPaid(0);

    setHoldMessage(`Cash refund: €${refundAmount.toFixed(2)}`);

    checkout({
      cash: refundAmount,
      card: 0,
    });

    return;
  }

  const safeAmount = Number(amount || 0);

  const newCash = cashPaid + safeAmount;
  setCashPaid(newCash);

  const totalPaid = newCash + cardPaid;
  const remaining = total - totalPaid;

  if (remaining > 0) return;

  setHoldMessage({
    type: "CHANGE",
    value: Math.abs(remaining),
  });

  checkout({
    cash: newCash,
    card: cardPaid,
  });
};


/*   const handleScan = async (e) => {
    if (e.key !== "Enter") return;

    const code = barcode.trim();

    if (!code) return;

    if (!shopId) {
      setError("Shop is still loading. Please wait.");
      setBarcode("");
      focusScanner();
      return;
    }

    if (saleCompleted) {
      setCart([]);
      setCashPaid(0);
      setCardPaid(0);
      setHoldMessage(null);
      setError("");
      setSaleCompleted(false);
      resetAgeCheckForNewSale();
    }

    try {
      const res = await axios.get(
        `${LOCAL_API_URL}/products/barcode/${encodeURIComponent(code)}`,
        {
          params: { shop_id: shopId },
        }
      );

      const product = res.data;

      setHoldMessage(null);

      if (inquiryMode) {
       setInquiryItem({
         ...product,
         qty: 1,
         cost_price: getCostPrice(product),
         category: product.category || "uncategorized",
         vat_code: product.vat_code || "A",
       });
      } else {
        if (handleAgeCheckBeforeAdd(product)) {
          setBarcode("");
          focusScanner();
          return;
        }

        setCart((prev) => {
          const existing = prev.find((i) => i.id === product.id);

          if (existing) {
            return prev.map((i) =>
              i.id === product.id ? { ...i, qty: i.qty + 1 } : i
            );
          }

          return [
            ...prev,
            {
              ...product,
              qty: 1,
              category: product.category || "uncategorized",
              vat_code: product.vat_code || "A",
              container_size_ml: product.container_size_ml || null,
              is_drs: product.is_drs || false,
              drs_amount: Number(product.drs_amount || 0),
            },
          ];
        });
      }

      setBarcode("");
      setError("");
      focusScanner();
    } catch (err) {
      playErrorBeep();

      setError("❌ Barcode not found");

      setTimeout(() => {
        setError("");
      }, 600);

      setBarcode("");
      focusScanner();
    }
  }; */

  const handleScan = async (e) => {
  if (e.key !== "Enter") return;

  const code = barcode.trim();

  if (!code) return;

  if (!shopId) {
    setError("Shop is still loading. Please wait.");
    setBarcode("");
    focusScanner();
    return;
  }

  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  try {
    const res = await axios.get(
      `${LOCAL_API_URL}/products/barcode/${encodeURIComponent(code)}`,
      {
        params: { shop_id: shopId },
      }
    );

    const product = res.data;

    setHoldMessage(null);

    // =========================
    // REFUND MODE
    // =========================
    if (refundMode) {
      const refundProductId = product.product_id || product.id;
      const refundPrice = -Math.abs(Number(product.price || 0));
      const refundCostPrice = -Math.abs(getCostPrice(product));
      const refundDrsAmount = -Math.abs(Number(product.drs_amount || 0));

      setCart((prev) => {
        const existing = prev.find(
          (i) =>
            i.is_refund &&
            String(i.product_id || "").trim() ===
              String(refundProductId || "").trim()
        );

        if (existing) {
          return prev.map((i) =>
            i.id === existing.id ? { ...i, qty: Number(i.qty || 1) + 1 } : i
          );
        }

        return [
          ...prev,
          {
            ...product,
            id: `refund-${refundProductId}-${Date.now()}`,
            product_id: refundProductId,
            cart_item_id: `refund-${refundProductId}-${Date.now()}`,
            name: `REFUND - ${product.name}`,
            price: refundPrice,
            cost_price: refundCostPrice,
            qty: 1,
            category: product.category || "uncategorized",
            vat_code: product.vat_code || "A",
            container_size_ml: product.container_size_ml || null,
            is_drs: product.is_drs || false,
            drs_amount: refundDrsAmount,
            is_refund: true,
            line_type: "refund",
          },
        ];
      });

      setHoldMessage(`${product.name} added as refund`);
      setBarcode("");
      setError("");
      focusScanner();
      return;
    }

    // =========================
    // INQUIRY MODE
    // =========================
    if (inquiryMode) {
      setInquiryItem({
        ...product,
        qty: 1,
        cost_price: getCostPrice(product),
        category: product.category || "uncategorized",
        vat_code: product.vat_code || "A",
      });
    } else {
      // =========================
      // NORMAL SALE MODE
      // =========================
      if (handleAgeCheckBeforeAdd(product)) {
        setBarcode("");
        focusScanner();
        return;
      }

      setCart((prev) => {
        const existing = prev.find(
          (i) => !i.is_refund && i.id === product.id
        );

        if (existing) {
          return prev.map((i) =>
            i.id === product.id ? { ...i, qty: i.qty + 1 } : i
          );
        }

        return [
          ...prev,
          {
            ...product,
            qty: 1,
            cost_price: getCostPrice(product),
            category: product.category || "uncategorized",
            vat_code: product.vat_code || "A",
            container_size_ml: product.container_size_ml || null,
            is_drs: product.is_drs || false,
            drs_amount: Number(product.drs_amount || 0),
          },
        ];
      });
    }

    setBarcode("");
    setError("");
    focusScanner();
  } catch (err) {
    playErrorBeep();

    setError("❌ Barcode not found");

    setTimeout(() => {
      setError("");
    }, 600);

    setBarcode("");
    focusScanner();
  }
};

//Open cashdrawer new addition

/*   const openCashDrawer = async () => {
  try {
    console.log("Opening cash drawer...");

    const res = await axios.post(`${LOCAL_API_URL}/cash-drawer/open`, {});

    console.log("Cash drawer opened:", res.data);
  } catch (err) {
    console.error(
      "Cash drawer open failed:",
      err.response?.data || err.message
    );
  }
}; */

  //Checkout Function

  /* const checkout = async (paymentBreakdown) => {
    if (!licenseStatus || licenseStatus.valid !== true) {
      setError(licenseError || "Licence is not valid. Checkout blocked.");

      setTimeout(() => {
        setError("");
      }, 1000);

      return;
    }

    if (!cart || cart.length === 0) {
      setError("❌ Cart is empty");
      return;
    }

    if (!shopId) {
      setError("Shop is still loading. Please wait.");
      return;
    }

    const safePaymentBreakdown =
      paymentBreakdown && typeof paymentBreakdown === "object"
        ? paymentBreakdown
        : { cash: 0, card: 0 };

    const vatSummary = {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
      E: 0,
    };

    cart.forEach((item) => {
      const code = item.vat_code || "A";
      const rate = vatRates[code] || 0;

      const itemTotal = Number(item.price || 0) * Number(item.qty || 0);
      const vatAmount = itemTotal - itemTotal / (1 + rate / 100);

      vatSummary[code] += vatAmount;
    });

    try {
      const saleItems = cart.map((item) => ({
        ...item,
        price: Number(item.price || 0),
        cost_price: getCostPrice(item),
        qty: Number(item.qty || 0),
        category: item.category || "uncategorized",
        vat_code: item.vat_code || item.vatCode || "A",
        drs_amount: Number(item.drs_amount || item.drsAmount || 0),
        is_drs: Boolean(item.is_drs || item.isDrs),
        container_size_ml: item.container_size_ml || item.containerSizeMl || null,
      }));

      const finalPaymentBreakdown = {
        cash: Number(safePaymentBreakdown.cash || 0),
        card: Number(safePaymentBreakdown.card || 0),
        change: Math.max(
          0,
          Number(safePaymentBreakdown.cash || 0) +
            Number(safePaymentBreakdown.card || 0) -
            Number(total || 0)
        ),
      };

      const res = await axios.post(`${LOCAL_API_URL}/sales`, {
        shop_id: shopId,
        items: saleItems,
        total,
        payment_method: "split",
        paymentMethod: "split",
        payment_breakdown: finalPaymentBreakdown,
        paymentBreakdown: finalPaymentBreakdown,
        vatSummary,
      });
      await openCashDrawer();

      setLastSale({
        ...res.data.sale,
        items: saleItems,
        total,
        paymentBreakdown: finalPaymentBreakdown,
        payment_breakdown: finalPaymentBreakdown,
      });

      setSaleCompleted(true);
      resetAgeCheckForNewSale();
      fetchSyncStatus();

      if (window.electron?.ipcRenderer) {
        window.electron.ipcRenderer.send(
          "open-cash-drawer",
          shopSettings?.drawer_com_port || "COM4"
        );
      } else {
        console.log("Electron not available, cash drawer skipped");
      }

      setError("");
    } catch (err) {
      console.log("Checkout error:", err.response?.data || err.message);
      setError(err.response?.data?.error || "❌ Payment failed");
    }
  }; */

const checkout = async (paymentBreakdown) => {
  if (!licenseStatus || licenseStatus.valid !== true) {
    setError(licenseError || "Licence is not valid. Checkout blocked.");

    setTimeout(() => {
      setError("");
    }, 1000);

    return;
  }

  if (!cart || cart.length === 0) {
    setError("❌ Cart is empty");
    return;
  }

  if (!shopId) {
    setError("Shop is still loading. Please wait.");
    return;
  }

  const safePaymentBreakdown =
    paymentBreakdown && typeof paymentBreakdown === "object"
      ? paymentBreakdown
      : { cash: 0, card: 0 };

  const isRefundSale =
    Number(total || 0) < 0 || cart.some((item) => item.is_refund);

  const vatSummary = {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
  };

 pricedCart.forEach((item) => {
  const code = item.vat_code || "A";
  const rate = vatRates[code] || 0;

  const effectivePrice = Number(
    item.effective_price ??
    item.price ??
    0
  );

  const itemTotal =
    effectivePrice *
    Number(item.qty || 0);

  const vatAmount =
    itemTotal -
    itemTotal / (1 + rate / 100);

  vatSummary[code] += vatAmount;
});

  try {
   const saleItems = pricedCart.map((item) => {
  const effectivePrice = Number(
    item.effective_price ??
    item.price ??
    0
  );

  const originalPrice = Number(
    item.original_price ??
    item.price ??
    0
  );

  return {
    ...item,

    // Actual price charged after promotion
    price: Number(effectivePrice.toFixed(4)),

    // Preserve shelf price for receipt/reporting
    original_price: Number(originalPrice.toFixed(4)),

    effective_price: Number(effectivePrice.toFixed(4)),

    discount_amount: Number(
      item.discount_amount || 0
    ),

    promo_applied: Boolean(
      item.promo_applied
    ),

    promotion_id:
      item.promotion_id || null,

    promotion_name:
      item.promotion_name || null,

    cost_price: getCostPrice(item),

    qty: Number(item.qty || 0),

    category:
      item.category || "uncategorized",

    vat_code:
      item.vat_code ||
      item.vatCode ||
      "A",

    drs_amount: Number(
      item.drs_amount ||
      item.drsAmount ||
      0
    ),

    is_drs: Boolean(
      item.is_drs ||
      item.isDrs
    ),

    container_size_ml:
      item.container_size_ml ||
      item.containerSizeMl ||
      null,

    is_refund: Boolean(item.is_refund),

    line_type:
      item.line_type ||
      (item.is_refund
        ? "refund"
        : "sale"),
  };
});

    const rawCash = Number(safePaymentBreakdown.cash || 0);
    const rawCard = Number(safePaymentBreakdown.card || 0);

    let finalCash = rawCash;
    let finalCard = rawCard;
    let finalChange = 0;

    if (isRefundSale) {
      // Refund payments should be negative so reports reduce cash/card correctly.
      finalCash = rawCash !== 0 ? -Math.abs(rawCash) : 0;
      finalCard = rawCard !== 0 ? -Math.abs(rawCard) : 0;

      // If no method came through, default refund to cash.
      if (finalCash === 0 && finalCard === 0) {
        finalCash = -Math.abs(Number(total || 0));
      }

      finalChange = 0;
    } else {
      finalChange = Math.max(
        0,
        rawCash + rawCard - Number(total || 0)
      );
    }

    const finalPaymentBreakdown = {
      cash: finalCash,
      card: finalCard,
      change: finalChange,
      is_refund: isRefundSale,
    };

    const paymentMethod = isRefundSale ? "refund" : "split";

    const currentUser = authUser || getAuthUser();

const res = await axios.post(`${LOCAL_API_URL}/sales`, {
  shop_id: shopId,

  user_id: currentUser?.id
    ? Number(currentUser.id)
    : null,

  items: saleItems,
  total: Number(total || 0),

  subtotal: Number(originalSubtotal.toFixed(2)),
  promotion_saving: Number(multiBuySaving.toFixed(2)),

  payment_method: paymentMethod,
  paymentMethod,

  payment_breakdown: finalPaymentBreakdown,
  paymentBreakdown: finalPaymentBreakdown,

  vatSummary,
  is_refund: isRefundSale,
});

    // Open cash drawer only for cash sale OR cash refund.
    // Do not open drawer for card-only sales/refunds.
// =========================
// OPEN CASH DRAWER
// Opens automatically after every completed checkout
// Electron decides whether to use COM or receipt printer
// =========================

// =========================
// OPEN CASH DRAWER
// Opens automatically after every completed checkout.
// If COM port is configured -> Electron uses COM.
// If COM port is blank -> Electron uses receipt printer.
// =========================

if (window.electron?.ipcRenderer) {
  const drawerComPort = String(
    shopSettings?.drawer_com_port ??
    shopSettings?.drawerComPort ??
    ""
  ).trim();

  const printerName = String(
    shopSettings?.printer_name ??
    shopSettings?.printerName ??
    ""
  ).trim();

  console.log("Opening cash drawer:", {
    drawerComPort,
    printerName,
  });

  window.electron.ipcRenderer.send(
    "open-cash-drawer",
    drawerComPort || null,
    printerName
  );
} else {
  console.log("Electron not available, cash drawer skipped");
}

   setLastSale({
  ...res.data.sale,

  items: saleItems,

  total: Number(total || 0),

  subtotal: Number(originalSubtotal.toFixed(2)),
  promotion_saving: Number(multiBuySaving.toFixed(2)),

  paymentBreakdown: finalPaymentBreakdown,
  payment_breakdown: finalPaymentBreakdown,

  is_refund: isRefundSale,
});

    setSaleCompleted(true);
    setRefundMode(false);
    resetAgeCheckForNewSale();
    fetchSyncStatus();
 
    setError("");
  } catch (err) {
    console.log("Checkout error:", err.response?.data || err.message);
    setError(err.response?.data?.error || "❌ Payment failed");
  }
};

  const pressKey = (num) => {
    setManualPrice((prev) => prev + num);
  };

  const clearKey = () => {
    setManualPrice("");
  };


  // Start of new Z report
  
const printZReport = (data) => {
  if (!data) {
    alert("No Z Report data found");
    return;
  }

  const safeNum = (value) => {
    const num = Number(value || 0);
    return Number.isFinite(num) ? num : 0;
  };

  const getLocalUser = () => {
    try {
      return getAuthUser() || {};
    } catch {
      try {
        return JSON.parse(
          localStorage.getItem("user") || "{}"
        );
      } catch {
        return {};
      }
    }
  };

  const getStoredShopSettings = () => {
    try {
      const cachedConfig = JSON.parse(
        localStorage.getItem("shop_config_cache") || "null"
      );

      const shopSettingsStored = JSON.parse(
        localStorage.getItem("shopSettings") || "null"
      );

      const shopSettingsAlt = JSON.parse(
        localStorage.getItem("shop_settings") || "null"
      );

      const settingsStored = JSON.parse(
        localStorage.getItem("settings") || "null"
      );

      return (
        cachedConfig ||
        shopSettingsStored ||
        shopSettingsAlt ||
        settingsStored ||
        {}
      );
    } catch {
      return {};
    }
  };

  const user = getLocalUser();
  const savedShopSettings = getStoredShopSettings();

  /*
    Use the current React shopSettings first,
    then cached settings.

    This is the same idea used by the normal
    receipt printer flow.
  */
  const activeShopSettings = {
    ...(savedShopSettings || {}),
    ...(shopSettings || {}),
  };

  const summary = data.summary || {};

  const categories =
    data.categories ||
    data.categorySummary ||
    data.category_summary ||
    {};

  const categoryRows = Object.entries(categories);

  // =========================
  // SHOP DETAILS
  // =========================


const rawDataShopName =
  data.shopName ||
  data.shop_name ||
  "";

const dataShopName =
  String(rawDataShopName).trim().toUpperCase() === "SHOP"
    ? ""
    : rawDataShopName;

const shopName =
  activeShopSettings.shop_name ||
  activeShopSettings.shopName ||
  activeShopSettings.receipt_name ||
  activeShopSettings.receiptName ||
  savedShopSettings.shop_name ||
  savedShopSettings.shopName ||
  savedShopSettings.receipt_name ||
  savedShopSettings.receiptName ||
  dataShopName ||
  user.shop_name ||
  user.shopName ||
  user.shop?.name ||
  user.shop?.shop_name ||
  "SHOP";

  const shopAddress =
    data.shopAddress ||
    data.shop_address ||
    data.address ||
    activeShopSettings.address ||
    activeShopSettings.shop_address ||
    activeShopSettings.shopAddress ||
    activeShopSettings.full_address ||
    activeShopSettings.fullAddress ||
    user.shop_address ||
    user.shopAddress ||
    user.address ||
    user.shop?.address ||
    "";

  const printerName =
    data.printer_name ||
    data.printerName ||
    activeShopSettings.printer_name ||
    activeShopSettings.printerName ||
    "Tysso Thermal Receipt Printer";

  const shiftId =
    data.shiftId ||
    data.shift_id ||
    data.shift ||
    "-";

  const closedBy =
    data.closedBy ||
    data.closed_by ||
    data.staffName ||
    data.staff_name ||
    user.name ||
    "-";

  const zNumber =
    data.zReportNumber ||
    data.z_report_number ||
    data.zNo ||
    data.z_no ||
    "-";

  const reportDate =
    data.date ||
    data.reportDate ||
    data.report_date ||
    new Date().toISOString();

  const reportFrom =
    data.from ||
    data.fromDate ||
    data.paymentsFrom ||
    data.payments_from ||
    reportDate;

  const reportTo =
    data.to ||
    data.toDate ||
    data.paymentsTo ||
    data.payments_to ||
    new Date().toISOString();

  const formatDateTime = (value) => {
    if (!value) return "-";

    try {
      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return String(value);
      }

      return date.toLocaleString();
    } catch {
      return String(value);
    }
  };

  const money = (value) =>
    safeNum(value).toFixed(2);

  // =========================
  // TOTALS
  // =========================

  const totalTransactions = safeNum(
    data.totalTransactions ||
      summary.totalTransactions
  );

  const totalSales = safeNum(
    summary.totalSales ||
      data.totalSales
  );

  const cashTotal = safeNum(
    summary.cashTotal ||
      data.cashTotal
  );

  const cardTotal = safeNum(
    summary.cardTotal ||
      data.cardTotal
  );

  const drsTotal = safeNum(
    summary.drsTotal ||
      data.drsTotal
  );

  const averageSale =
    totalTransactions > 0
      ? totalSales / totalTransactions
      : 0;

  const totalQtyFromCategories =
    categoryRows.reduce(
      (sum, [, item]) =>
        sum +
        safeNum(
          item?.qty ||
            item?.no
        ),
      0
    );

  const totalGrossFromCategories =
    categoryRows.reduce(
      (sum, [, item]) =>
        sum +
        safeNum(
          item?.gross ||
            item?.total ||
            item?.sales
        ),
      0
    );

  // =========================
  // PDF
  // =========================

  /*
    Z reports can be longer than normal receipts,
    so keep a reasonably long page.

    POS-80 has roughly 72mm printable width,
    therefore use 68mm as the safe right edge.
  */
  const pageWidth = 80;
  const pageHeight = 290;

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [pageWidth, pageHeight],
  });

  const left = 6;
  const right = 68;
  const centerX = 39;

  let y = 7;

  // =========================
  // PDF HELPERS
  // =========================

  const center = (
    text,
    size = 10,
    bold = true
  ) => {
    doc.setTextColor(0);

    doc.setFont(
      "helvetica",
      bold ? "bold" : "normal"
    );

    doc.setFontSize(size);

    doc.text(
      String(text || ""),
      centerX,
      y,
      {
        align: "center",
      }
    );

    y += size >= 12 ? 5.5 : 4.5;
  };

  const drawLine = () => {
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    doc.line(
      left,
      y,
      right,
      y
    );

    y += 3.5;
  };

  const printPageHeader = () => {
    y = 7;

    center(
      shopName,
      13,
      true
    );

    if (shopAddress) {
      const addressLines =
        String(shopAddress).match(
          /.{1,32}/g
        ) || [];

      addressLines
        .slice(0, 3)
        .forEach((line) => {
          center(
            line,
            8.5,
            false
          );
        });
    }

    center(
      "Z REPORT",
      11,
      true
    );

    drawLine();
  };

  const addPageIfNeeded = (
    neededSpace = 20
  ) => {
    if (
      y + neededSpace >
      pageHeight - 15
    ) {
      doc.addPage(
        [80, 290],
        "portrait"
      );

      printPageHeader();
    }
  };

  const sectionTitle = (title) => {
    addPageIfNeeded(18);

    y += 1;

    drawLine();

    doc.setTextColor(0);
    doc.setFont(
      "helvetica",
      "bold"
    );
    doc.setFontSize(9.5);

    doc.text(
      String(title),
      centerX,
      y,
      {
        align: "center",
      }
    );

    y += 4;

    drawLine();
  };

  const row = (label, value) => {
    addPageIfNeeded(7);

    doc.setTextColor(0);
    doc.setFont(
      "helvetica",
      "bold"
    );
    doc.setFontSize(9);

    doc.text(
      String(label).substring(
        0,
        24
      ),
      left,
      y
    );

    doc.text(
      String(value),
      right,
      y,
      {
        align: "right",
      }
    );

    y += 4.6;
  };

  const smallRow = (
    label,
    value
  ) => {
    addPageIfNeeded(7);

    doc.setTextColor(0);

    doc.setFont(
      "helvetica",
      "normal"
    );

    doc.setFontSize(8);

    doc.text(
      String(label).substring(
        0,
        20
      ),
      left,
      y
    );

    /*
      Date/time values can be long.
      Keep them inside printable width.
    */
    doc.text(
      String(value).substring(
        0,
        29
      ),
      right,
      y,
      {
        align: "right",
      }
    );

    y += 4.5;
  };

  // =========================
  // HEADER
  // =========================

  printPageHeader();

  row(
    "Report Date:",
    new Date(
      reportDate
    ).toLocaleDateString()
  );

  row(
    "Z No:",
    zNumber
  );

  if (
    shiftId &&
    shiftId !== "-"
  ) {
    row(
      "Shift ID:",
      shiftId
    );
  }

  row(
    "Closed By:",
    closedBy
  );

  drawLine();

  smallRow(
    "Payments From:",
    formatDateTime(reportFrom)
  );

  smallRow(
    "Payments To:",
    formatDateTime(reportTo)
  );

  // =========================
  // SUMMARY
  // =========================

  sectionTitle("SUMMARY");

  row(
    "Total Sales",
    `€${money(totalSales)}`
  );

  row(
    "Invoices",
    String(totalTransactions)
  );

  row(
    "Average Sale",
    `€${money(averageSale)}`
  );

  row(
    "Total Payments",
    `€${money(
      cashTotal + cardTotal
    )}`
  );

  drawLine();

  row(
    "Cash Sales",
    `€${money(cashTotal)}`
  );

  row(
    "Card Sales",
    `€${money(cardTotal)}`
  );

  if (drsTotal > 0) {
    row(
      "DRS Deposits",
      `€${money(drsTotal)}`
    );
  }

  drawLine();

  row(
    "Grand Total",
    `€${money(totalSales)}`
  );

  // =========================
  // PAYMENT BREAKDOWN
  // =========================

  sectionTitle(
    "PAYMENT BREAKDOWN"
  );

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(8.5);

  doc.text(
    "Currency",
    left,
    y
  );

  doc.text(
    "Type",
    29,
    y
  );

  doc.text(
    "Total",
    right,
    y,
    {
      align: "right",
    }
  );

  y += 4.5;

  drawLine();

  addPageIfNeeded(8);

  doc.setFont(
    "helvetica",
    "normal"
  );

  doc.setFontSize(8.5);

  doc.text(
    "EURO",
    left,
    y
  );

  doc.text(
    "CASH",
    29,
    y
  );

  doc.text(
    `€${money(cashTotal)}`,
    right,
    y,
    {
      align: "right",
    }
  );

  y += 5;

  doc.text(
    "EURO",
    left,
    y
  );

  doc.text(
    "CARD",
    29,
    y
  );

  doc.text(
    `€${money(cardTotal)}`,
    right,
    y,
    {
      align: "right",
    }
  );

  y += 5;

  drawLine();

  row(
    "EURO TOTAL:",
    `€${money(
      cashTotal + cardTotal
    )}`
  );


  // =========================
// VAT BREAKDOWN
// =========================

sectionTitle("VAT BREAKDOWN");

const vatSummary =
  data.vatSummary ||
  data.vat_summary ||
  {};

const vatRates = {
  A: 0,
  B: 23,
  C: 13.5,
  D: 5,
  E: 9,
};

doc.setFont("helvetica", "bold");
doc.setFontSize(8.5);

doc.text("Code", left, y);
doc.text("Rate", 32, y);
doc.text("VAT", right, y, {
  align: "right",
});

y += 4.5;

drawLine();

let totalVat = 0;

Object.entries(vatRates).forEach(([code, rate]) => {
  const vatAmount = safeNum(vatSummary[code]);

  totalVat += vatAmount;

  // Only show codes that have VAT,
  // but Code A (0%) is always shown.
  if (vatAmount === 0 && code !== "A") {
    return;
  }

  addPageIfNeeded(7);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8.5);

  doc.text(code, left, y);

  doc.text(
    `${rate}%`,
    32,
    y
  );

  doc.text(
    `€${money(vatAmount)}`,
    right,
    y,
    {
      align: "right",
    }
  );

  y += 5;
});

drawLine();

row(
  "TOTAL VAT:",
  `€${money(totalVat)}`
);


  // =========================
  // PRODUCT GROUP BREAKDOWN
  // =========================

  sectionTitle(
    "PRODUCT GROUP BREAKDOWN"
  );

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(8.3);

  doc.text(
    "Group",
    left,
    y
  );

  doc.text(
    "No",
    44,
    y,
    {
      align: "right",
    }
  );

  doc.text(
    "Total",
    right,
    y,
    {
      align: "right",
    }
  );

  y += 4.5;

  drawLine();

  if (
    categoryRows.length === 0
  ) {
    row(
      "No category data",
      ""
    );
  } else {
    categoryRows.forEach(
      ([category, value]) => {
        addPageIfNeeded(7);

        const categoryName =
          String(
            category ||
              "UNKNOWN"
          ).toUpperCase();

        const qty =
          safeNum(
            value?.qty ||
              value?.no
          );

        const total =
          safeNum(
            value?.gross ||
              value?.total ||
              value?.sales
          );

        doc.setFont(
          "helvetica",
          "normal"
        );

        doc.setFontSize(8.3);

        doc.text(
          categoryName.substring(
            0,
            21
          ),
          left,
          y
        );

        doc.text(
          String(
            qty.toFixed(0)
          ),
          44,
          y,
          {
            align: "right",
          }
        );

        doc.text(
          `€${money(total)}`,
          right,
          y,
          {
            align: "right",
          }
        );

        y += 5;
      }
    );
  }

  drawLine();

  addPageIfNeeded(8);

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(8.5);

  doc.text(
    "TOTAL:",
    left,
    y
  );

  doc.text(
    String(
      totalQtyFromCategories.toFixed(
        0
      )
    ),
    44,
    y,
    {
      align: "right",
    }
  );

  doc.text(
    `€${money(
      totalGrossFromCategories ||
        totalSales
    )}`,
    right,
    y,
    {
      align: "right",
    }
  );

  y += 5;

  drawLine();

  center(
    "--- End ---",
    9,
    true
  );

  // =========================
  // PRINT
  // =========================

  /*
    This now matches normal receipt printing:
    send both:
      PDF Data URL
      printer name

    Previously Z Report sent only the PDF,
    so Electron could fall back to the old
    Tysso printer instead of POS-80.
  */

  const pdfDataUrl =
    doc.output(
      "datauristring"
    );

  console.log(
    "Z Report generated"
  );

  console.log(
    "Z Report printer:",
    printerName
  );

  if (
    window.electron
      ?.ipcRenderer
  ) {
    window.electron.ipcRenderer.send(
      "print-receipt",
      pdfDataUrl,
      printerName
    );
  } else {
    console.log(
      "Electron not available, opening Z Report preview"
    );

    const pdfBlob =
      doc.output("blob");

    const pdfUrl =
      URL.createObjectURL(
        pdfBlob
      );

    window.open(
      pdfUrl,
      "_blank"
    );

    setTimeout(() => {
      URL.revokeObjectURL(
        pdfUrl
      );
    }, 60000);
  }
};

const getShopDetailsForZReport = async () => {
  const currentShopId =
    shopId ||
    localStorage.getItem("shop_id") ||
    JSON.parse(localStorage.getItem("user") || "{}")?.shop_id ||
    9;

  const SETTINGS_API_URL =
    process.env.REACT_APP_API_URL || "https://api.deskpos.ie";

  const possibleUrls = [
    `${SETTINGS_API_URL}/shop-settings/${currentShopId}`,
    `${SETTINGS_API_URL}/shop-settings?shop_id=${currentShopId}`,
    `${SETTINGS_API_URL}/shops/${currentShopId}/settings`,
    `${SETTINGS_API_URL}/super-admin/shops/${currentShopId}`,
  ];

  for (const url of possibleUrls) {
    try {
      const res = await axios.get(url);

      const data =
        res.data?.settings ||
        res.data?.shopSettings ||
        res.data?.shop ||
        res.data ||
        {};

      console.log("Z REPORT SHOP DETAILS FOUND:", url, data);

    const addressParts = [
  data.address_line_1,
  data.address_line_2,
  data.city,
  data.county,
  data.eircode,
].filter(Boolean);

return {
  shopName:
    data.receipt_name ||
    data.shop_name ||
    data.shopName ||
    data.name ||
    data.business_name ||
    data.businessName ||
    "SHOP",

  shopAddress:
    data.receipt_address ||
    data.shop_address ||
    data.shopAddress ||
    data.address ||
    data.business_address ||
    data.businessAddress ||
    addressParts.join(", "),
};
    } catch (err) {
      console.log("Shop detail URL failed:", url);
    }
  }

  return {
    shopName: "SHOP",
    shopAddress: "",
  };
};
  const closeDay = async () => {
    try {
      const res = await axios.post(`${LOCAL_API_URL}/reports/close-day`);

      const totalTransactions = Number(
        res.data.totalTransactions || res.data.summary?.totalTransactions || 0
      );

      if (totalTransactions === 0) {
        alert("No new sales to close.");
        return;
      }

const user = JSON.parse(localStorage.getItem("user") || "{}");

const savedShopSettings =
  JSON.parse(localStorage.getItem("shopSettings") || "null") ||
  JSON.parse(localStorage.getItem("shop_settings") || "null") ||
  JSON.parse(localStorage.getItem("settings") || "null") ||
  {};

console.log("Z REPORT USER:", user);
console.log("Z REPORT SAVED SHOP SETTINGS:", savedShopSettings);
console.log("Z REPORT RESPONSE:", res.data);

const shopDetailsForZReport = await getShopDetailsForZReport();

console.log("FINAL Z REPORT SHOP DETAILS:", shopDetailsForZReport);

printZReport({
  ...res.data,
  totalTransactions,
  shopName: shopDetailsForZReport.shopName,
  shopAddress: shopDetailsForZReport.shopAddress,
});

      fetchSyncStatus();
    } catch (err) {
      console.error("Close day error:", err.response?.data || err.message);
      alert("Failed to close day");
    }
  };

  
  const makeRefundCartItem = (item) => {
  const originalName = String(item.name || "Manual Item").replace(/^REFUND - /, "");

  return {
    ...item,
    id: `refund-${item.id || item.cart_item_id || Date.now()}-${Date.now()}`,
    cart_item_id: `refund-${item.cart_item_id || item.id || Date.now()}`,
    product_id: item.product_id || item.id || null,
    name: `REFUND - ${originalName}`,
    price: -Math.abs(Number(item.price || 0)),
    cost_price: -Math.abs(Number(item.cost_price || getCostPrice(item) || 0)),
    drs_amount: -Math.abs(Number(item.drs_amount || 0)),
    qty: Number(item.qty || 1),
    is_refund: true,
    line_type: "refund",
  };
};


//New Functions for manuual Device Entry

const resetDeviceSaleModal = () => {
  setShowDeviceSale(false);
  setDeviceStep(1);
  setDevicePrice("");
  setDeviceDescription("");
  setDeviceGuarantee(null);
};

const openDeviceSale = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  setDeviceStep(1);
  setDevicePrice("");
  setDeviceDescription("");
  setDeviceGuarantee(null);
  setShowDeviceSale(true);
  setError("");
};

const pressDeviceKey = (key) => {
  setDevicePrice((prev) => {
    if (key === "." && prev.includes(".")) {
      return prev;
    }

    return prev + key;
  });
};

const goToDeviceDescription = () => {
  const price = Number(devicePrice);

  if (!Number.isFinite(price) || price <= 0) {
    setError("Please enter a valid device price");
    return;
  }

  setError("");
  setDeviceStep(2);
};

const goToDeviceGuarantee = () => {
  const description = String(deviceDescription || "").trim();

  if (!description) {
    setError("Please enter the device description");
    return;
  }

  setError("");
  setDeviceStep(3);
};

const addDeviceItem = () => {
  const price = Number(devicePrice);
  const description = String(deviceDescription || "").trim();

  if (!Number.isFinite(price) || price <= 0) {
    setError("Please enter a valid device price");
    setDeviceStep(1);
    return;
  }

  if (!description) {
    setError("Please enter the device description");
    setDeviceStep(2);
    return;
  }

  if (!deviceGuarantee) {
    setError("Please select a guarantee");
    return;
  }

  const guaranteeLabel =
    `${deviceGuarantee} Month${deviceGuarantee === 1 ? "" : "s"}`;

  const item = {
    id: `manual-device-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-device-${Date.now()}`,

    name: description,
    device_description: description,

    price: Number(price.toFixed(2)),
    cost_price: 0,
    qty: 1,

    // Device VAT = 0%
    vat_code: "A",
    category: "device",

    guarantee_months: deviceGuarantee,
    guarantee_label: guaranteeLabel,

    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    is_manual: true,
  };

  const finalItem = refundMode
    ? makeRefundCartItem(item)
    : item;

  setCart((prev) => [
    ...prev,
    finalItem,
  ]);

  setHoldMessage(
    refundMode
      ? `${description} added as refund`
      : null
  );

  resetDeviceSaleModal();

  setError("");
  focusScanner();
};

// =======================================
// MARGIN VAT MANUAL SALE
// =======================================

const resetMarginVatSaleModal = () => {
  setShowMarginVatSale(false);
  setMarginVatStep(1);
  setMarginVatPrice("");
  setMarginVatDescription("");
  setMarginVatGuarantee(null);
};

const openMarginVatSale = () => {
  if (saleCompleted) {
    setCart([]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(null);
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  }

  setMarginVatStep(1);
  setMarginVatPrice("");
  setMarginVatDescription("");
  setMarginVatGuarantee(null);
  setShowMarginVatSale(true);
  setError("");
};

const pressMarginVatKey = (key) => {
  setMarginVatPrice((prev) => {
    if (key === "." && prev.includes(".")) {
      return prev;
    }

    return prev + key;
  });
};

const goToMarginVatDescription = () => {
  const price = Number(marginVatPrice);

  if (
    !Number.isFinite(price) ||
    price <= 0
  ) {
    setError(
      "Please enter a valid Margin VAT sale price"
    );

    return;
  }

  setError("");
  setMarginVatStep(2);
};

const goToMarginVatGuarantee = () => {
  const description = String(
    marginVatDescription || ""
  ).trim();

  if (!description) {
    setError(
      "Please enter the item description"
    );

    return;
  }

  setError("");
  setMarginVatStep(3);
};

const addMarginVatItem = () => {
  const price = Number(
    marginVatPrice
  );

  const description = String(
    marginVatDescription || ""
  ).trim();

  if (
    !Number.isFinite(price) ||
    price <= 0
  ) {
    setError(
      "Please enter a valid Margin VAT sale price"
    );

    setMarginVatStep(1);
    return;
  }

  if (!description) {
    setError(
      "Please enter the item description"
    );

    setMarginVatStep(2);
    return;
  }

  if (!marginVatGuarantee) {
    setError(
      "Please select a warranty"
    );

    return;
  }

  const item = {
    id:
      `manual-margin-vat-${Date.now()}-${Math.random()}`,

    cart_item_id:
      `manual-margin-vat-${Date.now()}`,

    name: description,

    device_description:
      description,

    price: Number(
      price.toFixed(2)
    ),

    /*
      Do not calculate normal VAT
      on the full selling price.

      Margin scheme accounting will
      be handled separately.
    */
    vat_code: "A",

    vat_scheme: "margin",

    is_margin_scheme: true,

    category: "margin-vat",

    cost_price: 0,

    qty: 1,

    guarantee_value:
      marginVatGuarantee.value,

    guarantee_unit:
      marginVatGuarantee.unit,

    guarantee_label:
      marginVatGuarantee.label,

    container_size_ml: null,

    is_drs: false,

    drs_amount: 0,

    is_manual: true,
  };

  const finalItem =
    refundMode
      ? makeRefundCartItem(item)
      : item;

  setCart((prev) => [
    ...prev,
    finalItem,
  ]);

  setHoldMessage(
    refundMode
      ? `${description} added as refund`
      : null
  );

  resetMarginVatSaleModal();

  setError("");
  focusScanner();
};


// End Of Functions Manual Device

  const addManualItem = () => {
    if (!manualPrice) return;

    setHoldMessage(null);

    let item = null;

    if (manualMode === "grocery") {
      item = {
        id: `manual-grocery-${Date.now()}-${Math.random()}`,
        /* name: "Grocery Item", */
        name: "Item (Non-VAT)",
        price: parseFloat(manualPrice),
        cost_price: 0,
        qty: 1,
        vat_code: "A",
        category: "grocery Non-vat",
        is_manual: true,
      };
    }

    if (manualMode === "grocery-vat") {
      item = {
        id: `manual-groceryvat-${Date.now()}-${Math.random()}`,
      /*   name: "Grocery Item (23% VAT)", */
      name: "Item (23% VAT)",
        price: parseFloat(manualPrice),
        cost_price: 0,
        qty: 1,
        vat_code: "B",
        category: "grocery Vat",
        is_manual: true,
      };
    }

    if (manualMode === "payzone") {
      item = {
        id: `manual-payzone-${Date.now()}-${Math.random()}`,
        name: "Payzone Service",
        price: parseFloat(manualPrice),
        cost_price: 0,
        qty: 1,
        vat_code: "A",
        category: "payzone",
        is_manual: true,
      };
    }

    if (manualMode === "lotto") {
      item = {
        id: `manual-lottery-${Date.now()}-${Math.random()}`,
        name: "Lottery / Scratch Card",
        price: parseFloat(manualPrice),
        cost_price: 0,
        qty: 1,
        vat_code: "A",
        category: "lottery",
        age_restricted: true,
        is_manual: true,
      };
    }

    if (manualMode === "prize") {
      item = {
        id: `manual-prize-${Date.now()}-${Math.random()}`,
        name: "Lottery Prize Paid",
        price: -Math.abs(parseFloat(manualPrice)),
        cost_price: 0,
        qty: 1,
        vat_code: "A",
        category: "lottery-payout",
        age_restricted: true,
        is_manual: true,
      };
    }

    if (manualMode === "news-magz") {
      item = {
        id: `manual-newz-${Date.now()}-${Math.random()}`,
        cart_item_id: `manual-${Date.now()}`,
        name: "Manual News / Magz",
        price: parseFloat(manualPrice),
        cost_price: 0,
        qty: 1,
        category: "news-magz",
        vat_code: "A",
        is_manual: true,
      };
    }

if (manualMode === "vape") {
  const vapePrice = Number(parseFloat(manualPrice).toFixed(2));

  item = {
    id: `manual-vape-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-vape-${Date.now()}`,
    name: "Vape Item",
    price: vapePrice,

    // 50% cost rule
    cost_price: Number((vapePrice * 0.5).toFixed(2)),

    qty: 1,
    vat_code: "B", // 23% VAT
    category: "vape",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    age_restricted: true,
    is_manual: true,
  };
}

if (manualMode === "nicotine-pouch") {
  const pouchPrice = Number(parseFloat(manualPrice).toFixed(2));

  item = {
    id: `manual-nicotine-pouch-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-nicotine-pouch-${Date.now()}`,
    name: "Nicotine Pouch",
    price: pouchPrice,

    // 50% cost rule
    cost_price: Number((pouchPrice * 0.5).toFixed(2)),

    qty: 1,
    vat_code: "B", // 23% VAT
    category: "nicotine-pouch",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    age_restricted: true,
    is_manual: true,
  };
}

if (manualMode === "e-liquid") {
  const liquidPrice = Number(parseFloat(manualPrice).toFixed(2));

  item = {
    id: `manual-e-liquid-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-e-liquid-${Date.now()}`,
    name: "E-Liquid",
    price: liquidPrice,

    // 50% cost rule
    cost_price: Number((liquidPrice * 0.5).toFixed(2)),

    qty: 1,
    vat_code: "B", // 23% VAT
    category: "e-liquid",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    age_restricted: true,
    is_manual: true,
  };
}

if (manualMode === "vape-accessories") {
  const accessoriesPrice = Number(parseFloat(manualPrice).toFixed(2));

  item = {
    id: `manual-vape-accessories-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-vape-accessories-${Date.now()}`,
    name: "Vape Accessories",
    price: accessoriesPrice,

    // 50% cost rule
    cost_price: Number((accessoriesPrice * 0.5).toFixed(2)),

    qty: 1,
    vat_code: "B", // 23% VAT
    category: "vape-accessories",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    age_restricted: true,
    is_manual: true,
  };
}

if (manualMode === "pods") {
  const podsPrice = Number(parseFloat(manualPrice).toFixed(2));

  item = {
    id: `manual-pods-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-pods-${Date.now()}`,
    name: "Pods",
    price: podsPrice,

    // 50% cost rule
    cost_price: Number((podsPrice * 0.5).toFixed(2)),

    qty: 1,
    vat_code: "B", // 23% VAT
    category: "pods",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    age_restricted: true,
    is_manual: true,
  };
}

if (manualMode === "phone-accessories") {
  const phoneAccessoriesPrice = Number(parseFloat(manualPrice).toFixed(2));

  item = {
    id: `manual-phone-accessories-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-phone-accessories-${Date.now()}`,
    name: "Phone Accessories",
    price: phoneAccessoriesPrice,

    // 50% cost rule
    cost_price: Number((phoneAccessoriesPrice * 0.5).toFixed(2)),

    qty: 1,
    vat_code: "B", // 23% VAT
    category: "phone-accessories",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    is_manual: true,
  };
}

if (manualMode === "print-scan-service") {
  const printScanPrice = Number(parseFloat(manualPrice).toFixed(2));

  item = {
    id: `manual-print-scan-service-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-print-scan-service-${Date.now()}`,
    name: "Print / Scan Service",
    price: printScanPrice,

    // 30% flat cost rule
    cost_price: Number((printScanPrice * 0.3).toFixed(2)),

    qty: 1,
    vat_code: "B", // 23% VAT
    category: "print-scan-service",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    is_manual: true,
  };
}

if (manualMode === "repair-service") {
  const repairServicePrice = Number(parseFloat(manualPrice).toFixed(2));

  item = {
    id: `manual-repair-service-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-repair-service-${Date.now()}`,
    name: "Repair Service",
    price: repairServicePrice,

    // No automatic cost calculation for now
    cost_price: 0,

    qty: 1,
    vat_code: "C",
    category: "repair-service",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    is_manual: true,
  };
}

    if (!item) return;

    if (saleCompleted) {
      setCart([]);
      setCashPaid(0);
      setCardPaid(0);
      setHoldMessage(null);
      setError("");
      setSaleCompleted(false);
      resetAgeCheckForNewSale();
    }

  if (
  !refundMode &&
  (manualMode === "lotto" ||
    manualMode === "prize" ||
    manualMode === "vape" ||
    manualMode === "nicotine-pouch" ||
    manualMode === "e-liquid" ||
    manualMode === "vape-accessories" ||
    manualMode === "pods") &&
  handleAgeCheckBeforeAdd(item)
) {
  setManualPrice("");
  setManualMode(null);
  focusScanner();
  return;
}

   const finalItem = refundMode ? makeRefundCartItem(item) : item;



setCart((prev) => [...prev, finalItem]);

setHoldMessage(
  refundMode
    ? `${item.name || "Manual item"} added as refund`
    : null
);

setManualPrice("");
setManualMode(null);
setError("");
focusScanner();
  };

  const addCoffeeItem = (type) => {
  let price = 0;
  let name = "";

  if (type === "medium") {
    price = 2.8;
    name = "Medium Coffee";
  } else if (type === "large") {
    price = 3.0;
    name = "Large Coffee";
  } else if (type === "tea") {
    price = 2.3;
    name = "Tea";
  }

  const item = {
    id: `manual-hotdrink-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-hotdrink-${Date.now()}`,
    name,
    price,
    cost_price: 0,
    qty: 1,
    vat_code: "B",
    category: "hot-drinks",
    container_size_ml: null,
    is_drs: false,
    drs_amount: 0,
    is_manual: true,
  };

  const finalItem = refundMode ? makeRefundCartItem(item) : item;

  if (saleCompleted) {
    setCart([finalItem]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(
      refundMode ? `${item.name || "Hot drink"} added as refund` : null
    );
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  } else {
    const finalItem = refundMode ? makeRefundCartItem(item) : item;

setCart((prev) => [...prev, finalItem]);

    setHoldMessage(
      refundMode ? `${item.name || "Hot drink"} added as refund` : null
    );
  }

  setShowCoffeeOptions(false);
  setManualPrice("");
  setManualMode(null);
  setError("");
  focusScanner();
};

const addCarrierBag = () => {
  const item = {
    id: `manual-carrier-bag-${Date.now()}-${Math.random()}`,
    cart_item_id: `manual-carrier-bag-${Date.now()}`,
    name: "Carrier Bag",
    price: 0.5,
    cost_price: 0,
    qty: 1,
    vat_code: "A",
    category: "carrier-bag",
    is_manual: true,
  };

  const finalItem = refundMode ? makeRefundCartItem(item) : item;

  if (saleCompleted) {
    setCart([finalItem]);
    setCashPaid(0);
    setCardPaid(0);
    setHoldMessage(
      refundMode ? `${item.name} added as refund` : null
    );
    setError("");
    setSaleCompleted(false);
    resetAgeCheckForNewSale();
  } else {
    setCart((prev) => [...prev, finalItem]);

    setHoldMessage(
      refundMode ? `${item.name} added as refund` : null
    );
  }

  setError("");
  focusScanner();
};

  const wrapText = (text, maxChars) => {
    const words = String(text || "").split(" ");
    const lines = [];
    let currentLine = "";

    words.forEach((word) => {
      if ((currentLine + word).length > maxChars) {
        lines.push(currentLine);
        currentLine = word + " ";
      } else {
        currentLine += word + " ";
      }
    });

    if (currentLine) lines.push(currentLine);

    return lines;
  };

const generateReceipt = (sale) => {
  if (!sale) {
    alert("No receipt found");
    return;
  }

  let cachedConfig = {};

  try {
    const saved = localStorage.getItem("shop_config_cache");
    cachedConfig = saved ? JSON.parse(saved) : {};
  } catch {
    cachedConfig = {};
  }

  const activeShopSettings = {
    ...(cachedConfig || {}),
    ...(shopSettings || {}),

    vat_number:
      shopSettings?.vat_number ||
      shopSettings?.vatNumber ||
      cachedConfig?.vat_number ||
      cachedConfig?.vatNumber ||
      "",

    vatNumber:
      shopSettings?.vat_number ||
      shopSettings?.vatNumber ||
      cachedConfig?.vat_number ||
      cachedConfig?.vatNumber ||
      "",
  };

  const receiptName =
    activeShopSettings?.shop_name ||
    activeShopSettings?.shopName ||
    activeShopSettings?.receipt_name ||
    activeShopSettings?.receiptName ||
    activeShopSettings?.business_name ||
    activeShopSettings?.businessName ||
    activeShopSettings?.name ||
    "POS";

  const address =
    activeShopSettings?.address ||
    activeShopSettings?.shop_address ||
    activeShopSettings?.shopAddress ||
    activeShopSettings?.full_address ||
    activeShopSettings?.fullAddress ||
    "";

  const addressLine1 =
    activeShopSettings?.address_line_1 ||
    activeShopSettings?.addressLine1 ||
    "";

  const addressLine2 =
    activeShopSettings?.address_line_2 ||
    activeShopSettings?.addressLine2 ||
    "";

  const phone =
    activeShopSettings?.phone ||
    activeShopSettings?.shop_phone ||
    activeShopSettings?.shopPhone ||
    activeShopSettings?.contact_phone ||
    activeShopSettings?.contactPhone ||
    "";

  const vatNumber =
    activeShopSettings?.vat_number ||
    activeShopSettings?.vatNumber ||
    "";

  const receiptFooter =
    activeShopSettings?.receipt_footer ||
    activeShopSettings?.receiptFooter ||
    activeShopSettings?.footer ||
    activeShopSettings?.footer_text ||
    activeShopSettings?.footerText ||
    "Thank You For Shopping!";

  const currency = activeShopSettings?.currency || "€";

  const printerName =
    activeShopSettings?.printer_name ||
    activeShopSettings?.printerName ||
    "Tysso Thermal Receipt Printer";

  const servedBy =
    sale?.served_by ||
    sale?.servedBy ||
    authUser?.name ||
    getAuthUser()?.name ||
    "";

  const shopType =
    activeShopSettings?.shop_type ||
    activeShopSettings?.shopType ||
    "";

  const rawInvoiceNumber =
    sale.invoice_number ||
    sale.invoiceNumber ||
    sale.receipt_number ||
    sale.receiptNumber ||
    sale.id ||
    "0";

  const invoiceNumber = String(rawInvoiceNumber)
    .replace(/\D/g, "")
    .slice(-6)
    .padStart(6, "0");

  const receiptDate =
    sale.created_at ||
    sale.createdAt ||
    sale.date ||
    new Date().toISOString();

  let receiptBreakdown = {};

  try {
    receiptBreakdown =
      typeof sale.payment_breakdown === "string"
        ? JSON.parse(sale.payment_breakdown)
        : sale.payment_breakdown ||
          sale.paymentBreakdown ||
          sale.payment ||
          {};
  } catch {
    receiptBreakdown = {};
  }

  let items = [];

  try {
    items =
      typeof sale.items === "string"
        ? JSON.parse(sale.items)
        : sale.items || [];
  } catch {
    items = [];
  }

  // ============================
  // TOTALS
  // ============================

  const productGrossTotal = items.reduce((sum, item) => {
    return (
      sum +
      Number(item.price || 0) *
        Number(item.qty || 0)
    );
  }, 0);

  const originalProductGrossTotal = items.reduce(
  (sum, item) => {
    const qty = Number(item.qty || 0);

    const originalPrice = Number(
      item.original_price ??
      item.price ??
      0
    );

    return sum + originalPrice * qty;
  },
  0
);

  const totalPromotionSaving = items.reduce(
    (sum, item) => {
      const promotionApplied =
        item.promo_applied === true ||
        item.promo_applied === 1 ||
        item.promo_applied === "true" ||
        item.is_promotion === true ||
        item.is_promotion === 1 ||
        item.is_promotion === "true";

      if (!promotionApplied || item.is_refund) {
        return sum;
      }

      const qty = Number(item.qty || 0);
      const currentPrice = Number(item.price || 0);

      const originalPrice = Number(
        item.original_price ??
          item.normal_price ??
          currentPrice
      );

      const savingPerItem = Math.max(
        0,
        Number(
          item.discount_amount ??
            originalPrice - currentPrice
        )
      );

      return sum + savingPerItem * qty;
    },
    0
  );

  const drsReceiptTotal = items.reduce(
    (sum, item) => {
      return (
        sum +
        Number(
          item.drs_amount ||
            item.drsAmount ||
            0
        ) *
          Number(item.qty || 0)
      );
    },
    0
  );

  const calculatedReceiptTotal =
    productGrossTotal + drsReceiptTotal;

  const receiptTotal = Number(
    sale.total ||
      calculatedReceiptTotal ||
      0
  );

  const cashReceiptPaid = Number(
    receiptBreakdown.cash ||
      receiptBreakdown.cashPaid ||
      receiptBreakdown.cash_paid ||
      sale.cash ||
      sale.cashPaid ||
      sale.cash_paid ||
      0
  );

  const cardReceiptPaid = Number(
    receiptBreakdown.card ||
      receiptBreakdown.cardPaid ||
      receiptBreakdown.card_paid ||
      sale.card ||
      sale.cardPaid ||
      sale.card_paid ||
      0
  );

  const totalPaidFromBreakdown = Number(
    receiptBreakdown.totalPaid ||
      receiptBreakdown.total_paid ||
      sale.totalPaid ||
      sale.total_paid ||
      0
  );

  const totalPaid =
    totalPaidFromBreakdown > 0
      ? totalPaidFromBreakdown
      : cashReceiptPaid + cardReceiptPaid;

  const changeDue = Number(
    receiptBreakdown.change ||
      receiptBreakdown.changeDue ||
      receiptBreakdown.change_due ||
      sale.change ||
      sale.changeDue ||
      sale.change_due ||
      Math.max(0, totalPaid - receiptTotal)
  );

  const formattedDate =
    new Date(receiptDate).toLocaleString();

  // ============================
  // PDF HEIGHT
  // ============================

  // ============================
// DYNAMIC RECEIPT HEIGHT
// ============================

const estimatedItemHeight = items.reduce((sum, item) => {
  const name = String(item.name || "");

  // Approximate how many printed lines the item name uses
  const lineCount = Math.max(
    1,
    Math.ceil(name.length / 13)
  );

  const nameHeight = lineCount * 4;

  const drsExtra =
    Number(
      item.drs_amount ||
      item.drsAmount ||
      0
    ) > 0
      ? 4
      : 0;

  const hasGuarantee =
    item.guarantee_label ||
    item.guaranteeLabel ||
    item.guarantee_months ||
    item.guaranteeMonths;

  const guaranteeExtra =
    hasGuarantee ? 5 : 0;

  // Small spacing between items
  const itemSpacing = 2;

  return (
    sum +
    nameHeight +
    drsExtra +
    guaranteeExtra +
    itemSpacing
  );
}, 0);

/*
  Base receipt content:
  shop header
  invoice/date/staff
  table headers
  subtotal/total
  payment section
  VAT
  footer

  Additional item height is added dynamically.
*/
const estimatedReceiptHeight = Math.max(
  118,
  100 + estimatedItemHeight
);

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: [80, estimatedReceiptHeight],
  });

  // POS-80 safe printable area
  const leftX = 6;
  const rightX = 68;
  const centerX = 39;

  const qtyX = 34;
  const vatX = 47;

  let y = 7;

  // ============================
  // SHOP HEADER
  // ============================

  doc.setFont("courier", "bold");
  doc.setFontSize(14);

  doc.text(receiptName, centerX, y, {
    align: "center",
  });

  y += 5;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);

  if (address) {
    const addressLines = wrapText(
      String(address),
      30
    );

    addressLines.forEach((line) => {
      doc.text(line, centerX, y, {
        align: "center",
      });

      y += 3.5;
    });
  }

  if (!address && addressLine1) {
    doc.text(addressLine1, centerX, y, {
      align: "center",
    });

    y += 3.5;
  }

  if (!address && addressLine2) {
    doc.text(addressLine2, centerX, y, {
      align: "center",
    });

    y += 3.5;
  }

  if (phone) {
    doc.text(
      `Tel: ${phone}`,
      centerX,
      y,
      {
        align: "center",
      }
    );

    y += 3.5;
  }

  if (vatNumber) {
    doc.text(
      `VAT No: ${vatNumber}`,
      centerX,
      y,
      {
        align: "center",
      }
    );

    y += 3.5;
  }

  if (shopType) {
    doc.setFontSize(8);

    doc.text(
      shopType.toUpperCase(),
      centerX,
      y,
      {
        align: "center",
      }
    );

    y += 3.5;
  }

  doc.setFontSize(9);

  // Reduced gap before first separator
  y += 2;

  doc.line(leftX, y, rightX, y);

  y += 4;

  // ============================
  // INVOICE
  // ============================

  doc.text(
    `Invoice No: ${invoiceNumber}`,
    leftX,
    y
  );

  y += 3.5;

  doc.text(
    `Date: ${formattedDate}`,
    leftX,
    y
  );

  y += 3.5;

  if (servedBy) {
    doc.text(
      `Served by: ${servedBy}`,
      leftX,
      y
    );

    y += 3.5;
  }

  // Smaller gap after staff name
  y += 2;

  doc.line(leftX, y, rightX, y);

  y += 4;

  // ============================
  // ITEM HEADER
  // ============================

  doc.setFont("courier", "bold");

  doc.text("Item", leftX, y);

  doc.text("Qty", qtyX, y, {
    align: "center",
  });

  doc.text("VAT", vatX, y, {
    align: "center",
  });

  doc.text("Total", rightX, y, {
    align: "right",
  });

  y += 3;

  doc.line(leftX, y, rightX, y);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);

  y += 4;

  // ============================
  // ITEMS
  // ============================

  items.forEach((item) => {
   const qty = Number(item.qty || 0);

const chargedPrice = Number(
  item.price || 0
);

const originalPrice = Number(
  item.original_price ??
  item.normal_price ??
  chargedPrice
);

// What customer sees on receipt
const itemTotal =
  originalPrice * qty;

/* // What was actually charged
const chargedItemTotal =
  chargedPrice * qty; */

    const drsAmount = Number(
      item.drs_amount ||
        item.drsAmount ||
        0
    );

    const drsTotal = drsAmount * qty;

    const vatRate =
      vatRates[item.vat_code || "A"] || 0;

  const vatAmount =
  itemTotal -
  itemTotal /
    (1 + vatRate / 100);

    const rawItemName =
      String(item.name || "");

    const vatNameMatch = rawItemName.match(
      /^(.*?)\s*(\([^)]*VAT\))$/i
    );

    let nameLines = [];

    if (vatNameMatch) {
      const mainName =
        vatNameMatch[1].trim();

      const vatText =
        vatNameMatch[2].trim();

      nameLines = [
        ...wrapText(mainName, 13),
        vatText,
      ];
    } else {
      nameLines = wrapText(
        rawItemName,
        13
      );
    }

    nameLines.forEach((line, index) => {
      doc.text(
        line,
        leftX,
        y + index * 4
      );
    });

    doc.text(
      String(qty),
      qtyX,
      y,
      {
        align: "center",
      }
    );

    doc.text(
      `${currency}${vatAmount.toFixed(2)}`,
      vatX,
      y,
      {
        align: "center",
      }
    );

    doc.text(
      `${currency}${itemTotal.toFixed(2)}`,
      rightX,
      y,
      {
        align: "right",
      }
    );

    // Reduced spacing after product
    y += nameLines.length * 4;


// ============================
// DEVICE GUARANTEE
// ============================

const guaranteeLabel =
  item.guarantee_label ||
  item.guaranteeLabel ||
  (
    item.guarantee_months ||
    item.guaranteeMonths
      ? `${
          item.guarantee_months ||
          item.guaranteeMonths
        } Month${
          Number(
            item.guarantee_months ||
            item.guaranteeMonths
          ) === 1
            ? ""
            : "s"
        }`
      : ""
  );

if (guaranteeLabel) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);

  doc.text(
    `Guarantee: ${guaranteeLabel}`,
    leftX,
    y
  );

  y += 4;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
}

    // DRS
    if (drsTotal > 0) {
      doc.setFontSize(8);

      doc.text(
        `DRS ${qty} x ${currency}${drsAmount.toFixed(2)}`,
        leftX,
        y
      );

      doc.text(
        `${currency}${drsTotal.toFixed(2)}`,
        rightX,
        y,
        {
          align: "right",
        }
      );

      y += 4;

      doc.setFontSize(9);
    }

    y += 1;
  });

  // Reduced gap after items
  y += 1;

  doc.line(leftX, y, rightX, y);

  y += 4;

  // ============================
  // VAT TOTAL
  // ============================

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  const totalVat = items.reduce(
    (sum, item) => {
      const itemTotal =
        Number(item.price || 0) *
        Number(item.qty || 0);

      const vatRate =
        vatRates[item.vat_code || "A"] || 0;

      const vatAmount =
        itemTotal -
        itemTotal /
          (1 + vatRate / 100);

      return sum + vatAmount;
    },
    0
  );

  // ============================
  // SUBTOTAL
  // ============================

  doc.text(
    "Subtotal:",
    leftX,
    y
  );

doc.text(
  `${currency}${originalProductGrossTotal.toFixed(2)}`,
  rightX,
  y,
  {
    align: "right",
  }
);

  y += 4;


if (totalPromotionSaving > 0) {
  doc.text(
    "Multi-Buy Saving:",
    leftX,
    y
  );

  doc.text(
    `-${currency}${totalPromotionSaving.toFixed(2)}`,
    rightX,
    y,
    {
      align: "right",
    }
  );

  y += 4;
}

  // ============================
  // DRS TOTAL
  // ============================

  if (drsReceiptTotal > 0) {
    doc.text(
      "DRS Deposit:",
      leftX,
      y
    );

    doc.text(
      `${currency}${drsReceiptTotal.toFixed(2)}`,
      rightX,
      y,
      {
        align: "right",
      }
    );

    y += 4;
  }

  // ============================
  // TOTAL
  // ============================

  doc.setFont(
    "helvetica",
    "bold"
  );

  doc.setFontSize(12);

  doc.text(
    "TOTAL PAID:",
    leftX,
    y
  );

  doc.text(
    `${currency}${receiptTotal.toFixed(2)}`,
    rightX,
    y,
    {
      align: "right",
    }
  );



  doc.setFont(
    "helvetica",
    "normal"
  );

  doc.setFontSize(10);

  // Was 9mm - reduced significantly
  y += 6;

  // ============================
  // PAYMENT
  // ============================

  doc.text(
    "Cash",
    leftX,
    y
  );

  doc.text(
    `${currency}${cashReceiptPaid.toFixed(2)}`,
    rightX,
    y,
    {
      align: "right",
    }
  );

  y += 4.5;

  doc.text(
    "Card",
    leftX,
    y
  );

  doc.text(
    `${currency}${cardReceiptPaid.toFixed(2)}`,
    rightX,
    y,
    {
      align: "right",
    }
  );

  y += 4.5;

  doc.text(
    "Change",
    leftX,
    y
  );

  doc.text(
    `${currency}${changeDue.toFixed(2)}`,
    rightX,
    y,
    {
      align: "right",
    }
  );

  y += 4.5;

  doc.text(
    "VAT Charged:",
    leftX,
    y
  );

  doc.text(
    `${currency}${totalVat.toFixed(2)}`,
    rightX,
    y,
    {
      align: "right",
    }
  );

  // Reduced gap before footer separator
  y += 4;

  doc.line(leftX, y, rightX, y);

  // Was 7mm
  y += 5;

  // ============================
  // FOOTER
  // ============================

  doc.setFontSize(9);
  doc.setFont(
    "helvetica",
    "normal"
  );

  if (receiptFooter) {
    const footerLines = wrapText(
      String(receiptFooter),
      34
    );

    footerLines.forEach((line) => {
      doc.text(
        line,
        centerX,
        y,
        {
          align: "center",
        }
      );

      y += 3.5;
    });
  }

  // ============================
  // PRINT / PREVIEW
  // ============================

  const pdfDataUrl =
    doc.output("datauristring");

  if (window.electron?.ipcRenderer) {
    window.electron.ipcRenderer.send(
      "print-receipt",
      pdfDataUrl,
      printerName
    );
  } else {
    console.log(
      "Electron not available, opening receipt preview in browser"
    );

    const pdfBlob =
      doc.output("blob");

    const pdfUrl =
      URL.createObjectURL(pdfBlob);

    window.open(
      pdfUrl,
      "_blank"
    );

    setTimeout(() => {
      URL.revokeObjectURL(pdfUrl);
    }, 60000);
  }
};

  const increaseQty = (id) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: Number(item.qty || 0) + 1 } : item
      )
    );
  };

  const decreaseQty = (id) => {
    setCart((prev) =>
      prev
        .map((item) =>
          item.id === id
            ? { ...item, qty: Number(item.qty || 0) - 1 }
            : item
        )
        .filter((item) => Number(item.qty || 0) > 0)
    );
  };

  const removeItem = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  const reprintLastReceipt = async () => {
    try {
      if (lastSale) {
        generateReceipt(lastSale);
        return;
      }

      const res = await axios.get(`${LOCAL_API_URL}/sales/latest`);
      generateReceipt(res.data);
    } catch (err) {
      console.error("Reprint receipt error:", err.response?.data || err.message);
      alert("No receipt found to print");
    }
  };

  const getEnabledButtons = () => {
    const raw =
      shopSettings?.enabled_buttons || shopSettings?.enabledButtons || null;

    if (!raw) return null;

    if (typeof raw === "string") {
      try {
        return JSON.parse(raw);
      } catch {
        return null;
      }
    }

    return raw;
  };

  const enabledButtons = getEnabledButtons();

const isButtonEnabled = (buttonName) => {
  // Wait until local shop settings are available.
  if (!shopSettings || !enabledButtons) {
    return false;
  }

  // Some POS buttons belong to the same
  // Super Admin feature control.
  const fallbackMap = {
    groceryVat: "grocery",
    prize: "lotto",
  };

  let value = enabledButtons[buttonName];

  // If this button has no individual setting,
  // use its parent feature setting.
  if (
    (value === undefined || value === null) &&
    fallbackMap[buttonName]
  ) {
    value =
      enabledButtons[
        fallbackMap[buttonName]
      ];
  }

  // No configuration = disabled.
  if (
    value === undefined ||
    value === null
  ) {
    return false;
  }

  if (value === false) return false;
  if (value === "false") return false;
  if (value === 0) return false;
  if (value === "0") return false;

  return true;
};

const cancelRefundMode = () => {
  setRefundMode(false);

  setCart((prev) =>
    prev.filter((item) => !item.is_refund && item.line_type !== "refund")
  );

  setCashPaid(0);
  setCardPaid(0);
  setHoldMessage(null);
  setError("");
  focusScanner();
};

const handleClrButton = () => {
  if (refundMode) {
    cancelRefundMode();
    return;
  }

  if (inquiryMode) {
    setInquiryMode(false);
    setBarcode("");
    setManualPrice("");
    setManualMode(null);
    setHoldMessage(null);
    setError("");
    focusScanner();
    return;
  }

  setBarcode("");
  setManualPrice("");
  setManualMode(null);
  setHoldMessage(null);
  setError("");
  focusScanner();
};

const isPromoItem = (item) => {
  const currentPrice = Number(item?.price || 0);

  const originalPrice = Number(
    item?.original_price ??
      item?.normal_price ??
      currentPrice
  );

  return (
    item?.promo_applied === true ||
    item?.promo_applied === 1 ||
    item?.promo_applied === "true" ||
    item?.is_promotion === true ||
    item?.is_promotion === 1 ||
    item?.is_promotion === "true" ||
    Number(item?.promotion_id || 0) > 0 ||
    Number(item?.discount_amount || 0) > 0 ||
    originalPrice > currentPrice
  );
};

  return (
    <div className="pos-page">
      <div className="pos-main-topbar">
        <div
          className={
            syncStatus.online
              ? "pos-main-topbar server-online"
              : "pos-main-topbar server-offline"
          }
        >
          <div className="pos-topbar-left">
            <div className="topbar-status-row">
              <span className="topbar-label">Server</span>
              <strong>{syncStatus.online ? "Online" : "Offline"}</strong>
            </div>

            <div className="topbar-status-row">
              <span className="topbar-label">Sync</span>
              <strong>{syncStatus.online ? "Ready" : "Offline Mode"}</strong>
            </div>

            <div className="topbar-status-row">
              <span className="topbar-label">Pending</span>
              <strong>{syncStatus.pendingSales || 0}</strong>
            </div>
          </div>

          <div className="pos-topbar-center">
         <h1>
  {(() => {
    const name = String(
      shopSettings?.shop_name ||
      shopSettings?.shopName ||
      shopSettings?.receipt_name ||
      shopSettings?.receiptName ||
      authUser?.shop_name ||
      authUser?.shopName ||
      ""
    ).trim();

    const invalidNames = [
      "",
      "real shop name",
      "shop",
      "pos",
    ];

    if (
      invalidNames.includes(
        name.toLowerCase()
      )
    ) {
      return "Loading shop...";
    }

    return name;
  })()}
</h1>
          </div>

          <div className="pos-topbar-right">
            <div className="pos-date-time">
              <strong>
                {currentDateTime.toLocaleTimeString("en-IE", {
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </strong>

              <span>
                {currentDateTime.toLocaleDateString("en-IE", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            </div>

            <div className="pos-user-info">
              <strong>{authUser?.name || "User"}</strong>
              <span>{authUser?.role || "cashier"}</span>
            </div>

            {appVersion && (
              <div className="pos-version-label">v{appVersion}</div>
            )}

            <button onClick={handleLogout}>Logout</button>
          </div>
        </div>
      </div>

      <div className="pos-container">
        {licenseStatus && licenseStatus.valid === false && (
          <div className="license-warning">
            Licence Error: {licenseError || "Licence is not valid"}
          </div>
        )}

        <div className="left-panel">
          <button className="receipt-btn" onClick={reprintLastReceipt}>
            Print Receipt
          </button>

          {isButtonEnabled("grocery") && (
            <button
              className="pos-btn grocery-btn"
              onClick={() => setManualMode("grocery")}
            >
              Item Non-VAT
            </button>
          )}

          {isButtonEnabled("groceryVat") && (
            <button
              className="pos-btn groceryvat-btn"
              onClick={() => setManualMode("grocery-vat")}
            >
              Item VAT
            </button>
          )}

          {isButtonEnabled("payzone") && (
            <button
              className="pos-btn payzone-btn"
              onClick={() => setManualMode("payzone")}
            >
              Payzone
            </button>
          )}

          {isButtonEnabled("lotto") && (
            <button
              className="pos-btn lotto-btn"
              onClick={() => setManualMode("lotto")}
            >
              Lotto / Scratch Card In
            </button>
          )}

          {isButtonEnabled("prize") && (
            <button
              className="prize-btn"
              onClick={() => setManualMode("prize")}
            >
              Lotto / Scratch Card Prize Out
            </button>
          )}

          {isButtonEnabled("newsMagz") && (
            <button
              className="manual-btn magz-btn"
              onClick={() => setManualMode("news-magz")}
            >
              News / Magz
            </button>
          )}

          {isButtonEnabled("coffee") && (
            <button
              className="manual-btn coffee-btn"
              onClick={() => setShowCoffeeOptions(true)}
            >
              Hot Drinks
            </button>
          )}

          {isButtonEnabled("carrierBag") && (
            <button className="pos-btn bag-btn" onClick={addCarrierBag}>
              Carrier Bag €0.50
            </button>
          )}

          {showCoffeeOptions && (
            <div className="manual-popup-overlay">
              <div className="manual-popup">
                <h2>Select Coffee Size</h2>

                <button onClick={() => addCoffeeItem("medium")}>
                  Medium Coffee €2.80
                </button>

                <button onClick={() => addCoffeeItem("large")}>
                  Large Coffee €3.00
                </button>

                <button onClick={() => addCoffeeItem("tea")}>Tea €2.30</button>

                <button onClick={() => setShowCoffeeOptions(false)}>
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>

        {showDeviceSale && (
  <div className="manual-modal-overlay">
    <div className="manual-modal device-sale-modal">

      {/* =========================
          STEP 1 - PRICE
      ========================= */}
      {deviceStep === 1 && (
        <>
          <h3 className="manual-modal-title">
            Device Sale - Enter Price
          </h3>

          <div className="device-step-label">
            Step 1 of 3
          </div>

          <div className="manual-price-display">
            €{devicePrice || "0.00"}
          </div>

          <div className="manual-keypad">
            <button onClick={() => pressDeviceKey("1")}>1</button>
            <button onClick={() => pressDeviceKey("2")}>2</button>
            <button onClick={() => pressDeviceKey("3")}>3</button>

            <button onClick={() => pressDeviceKey("4")}>4</button>
            <button onClick={() => pressDeviceKey("5")}>5</button>
            <button onClick={() => pressDeviceKey("6")}>6</button>

            <button onClick={() => pressDeviceKey("7")}>7</button>
            <button onClick={() => pressDeviceKey("8")}>8</button>
            <button onClick={() => pressDeviceKey("9")}>9</button>

            <button
              className="decimal-key"
              onClick={() => pressDeviceKey(".")}
            >
              .
            </button>

            <button onClick={() => pressDeviceKey("0")}>0</button>

            <button
              className="backspace-key"
              onClick={() =>
                setDevicePrice((prev) => prev.slice(0, -1))
              }
            >
              ⌫
            </button>

            <button
              className="clear-key"
              onClick={() => setDevicePrice("")}
            >
              Clear
            </button>

            <button
              className="ok-key"
              onClick={goToDeviceDescription}
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* =========================
          STEP 2 - DESCRIPTION
      ========================= */}
      {deviceStep === 2 && (
        <>
          <h3 className="manual-modal-title">
            Device Details
          </h3>

          <div className="device-step-label">
            Step 2 of 3
          </div>

          <div className="device-price-summary">
            Sale Price: €{Number(devicePrice || 0).toFixed(2)}
          </div>

          <label className="device-description-label">
            Device Description
          </label>

          <input
            type="text"
            className="device-description-input"
            value={deviceDescription}
            onChange={(e) =>
              setDeviceDescription(e.target.value)
            }
            placeholder="Example: iPhone 16 128GB Black"
            autoFocus
          />

          <div className="device-navigation-buttons">
            <button
              type="button"
              className="device-back-btn"
              onClick={() => {
                setError("");
                setDeviceStep(1);
              }}
            >
              Back
            </button>

            <button
              type="button"
              className="device-next-btn"
              onClick={goToDeviceGuarantee}
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* =========================
          STEP 3 - GUARANTEE
      ========================= */}
      {deviceStep === 3 && (
        <>
          <h3 className="manual-modal-title">
            Select Guarantee
          </h3>

          <div className="device-step-label">
            Step 3 of 3
          </div>

          <div className="device-summary-box">
            <strong>{deviceDescription}</strong>

            <span>
              €{Number(devicePrice || 0).toFixed(2)}
            </span>
          </div>

          <div className="device-guarantee-grid">
            {[1, 3, 6, 12].map((months) => (
              <button
                type="button"
                key={months}
                className={
                  deviceGuarantee === months
                    ? "device-guarantee-btn selected"
                    : "device-guarantee-btn"
                }
                onClick={() =>
                  setDeviceGuarantee(months)
                }
              >
                {months} Month{months === 1 ? "" : "s"}
              </button>
            ))}
          </div>

          <div className="device-navigation-buttons">
            <button
              type="button"
              className="device-back-btn"
              onClick={() => {
                setError("");
                setDeviceStep(2);
              }}
            >
              Back
            </button>

            <button
              type="button"
              className="device-add-btn"
              disabled={!deviceGuarantee}
              onClick={addDeviceItem}
            >
              Add Device
            </button>
          </div>
        </>
      )}

      <button
        type="button"
        className="manual-cancel-btn"
        onClick={() => {
          resetDeviceSaleModal();
          setError("");
          focusScanner();
        }}
      >
        Cancel
      </button>
    </div>
  </div>
)}

{showMarginVatSale && (
  <div className="manual-modal-overlay">
    <div className="manual-modal device-sale-modal">

      {/* =========================
          STEP 1 - PRICE
      ========================= */}

      {marginVatStep === 1 && (
        <>
          <h3 className="manual-modal-title">
            Margin VAT - Enter Sale Price
          </h3>

          <div className="device-step-label">
            Step 1 of 3
          </div>

          <div className="manual-price-display">
            €{marginVatPrice || "0.00"}
          </div>

          <div className="manual-keypad">
            <button
              onClick={() =>
                pressMarginVatKey("1")
              }
            >
              1
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("2")
              }
            >
              2
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("3")
              }
            >
              3
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("4")
              }
            >
              4
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("5")
              }
            >
              5
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("6")
              }
            >
              6
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("7")
              }
            >
              7
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("8")
              }
            >
              8
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("9")
              }
            >
              9
            </button>

            <button
              className="decimal-key"
              onClick={() =>
                pressMarginVatKey(".")
              }
            >
              .
            </button>

            <button
              onClick={() =>
                pressMarginVatKey("0")
              }
            >
              0
            </button>

            <button
              className="backspace-key"
              onClick={() =>
                setMarginVatPrice(
                  (prev) =>
                    prev.slice(0, -1)
                )
              }
            >
              ⌫
            </button>

            <button
              className="clear-key"
              onClick={() =>
                setMarginVatPrice("")
              }
            >
              Clear
            </button>

            <button
              className="ok-key"
              onClick={
                goToMarginVatDescription
              }
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* =========================
          STEP 2 - DESCRIPTION
      ========================= */}

      {marginVatStep === 2 && (
        <>
          <h3 className="manual-modal-title">
            Margin VAT Item Details
          </h3>

          <div className="device-step-label">
            Step 2 of 3
          </div>

          <div className="device-price-summary">
            Sale Price: €
            {Number(
              marginVatPrice || 0
            ).toFixed(2)}
          </div>

          <label className="device-description-label">
            Item Description
          </label>

          <input
            type="text"
            className="device-description-input"
            value={
              marginVatDescription
            }
            onChange={(e) =>
              setMarginVatDescription(
                e.target.value
              )
            }
            placeholder="Example: iPhone 14 128GB Used"
            autoFocus
          />

          <div className="device-navigation-buttons">
            <button
              type="button"
              className="device-back-btn"
              onClick={() => {
                setError("");
                setMarginVatStep(1);
              }}
            >
              Back
            </button>

            <button
              type="button"
              className="device-next-btn"
              onClick={
                goToMarginVatGuarantee
              }
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* =========================
          STEP 3 - WARRANTY
      ========================= */}

      {marginVatStep === 3 && (
        <>
          <h3 className="manual-modal-title">
            Select Warranty
          </h3>

          <div className="device-step-label">
            Step 3 of 3
          </div>

          <div className="device-summary-box">
            <strong>
              {marginVatDescription}
            </strong>

            <span>
              €
              {Number(
                marginVatPrice || 0
              ).toFixed(2)}
            </span>
          </div>

          <div className="device-guarantee-grid">
            {marginVatWarrantyOptions.map(
              (option) => {
                const selected =
                  marginVatGuarantee
                    ?.label ===
                  option.label;

                return (
                  <button
                    type="button"
                    key={option.label}
                    className={
                      selected
                        ? "device-guarantee-btn selected"
                        : "device-guarantee-btn"
                    }
                    onClick={() =>
                      setMarginVatGuarantee(
                        option
                      )
                    }
                  >
                    {option.label}
                  </button>
                );
              }
            )}
          </div>

          <div className="device-navigation-buttons">
            <button
              type="button"
              className="device-back-btn"
              onClick={() => {
                setError("");
                setMarginVatStep(2);
              }}
            >
              Back
            </button>

            <button
              type="button"
              className="device-add-btn"
              disabled={
                !marginVatGuarantee
              }
              onClick={
                addMarginVatItem
              }
            >
              Add Margin VAT Item
            </button>
          </div>
        </>
      )}

      <button
        type="button"
        className="manual-cancel-btn"
        onClick={() => {
          resetMarginVatSaleModal();
          setError("");
          focusScanner();
        }}
      >
        Cancel
      </button>
    </div>
  </div>
)}

        <div
          className={`cart-section ${saleCompleted ? "sale-completed-view" : ""}`}
        >
          <input
            ref={scannerRef}
            id="scanner"
            placeholder="Scan barcode..."
            value={barcode}
            onChange={(e) => setBarcode(e.target.value)}
            onKeyDown={handleScan}
            className="scanner-input"
          />

          {error && <div className="error">{error}</div>}

          <div className="cart clean-cart">
            {cart.length === 0 ? (
              <p className="cart-empty">No items scanned</p>
            ) : (
              <div className="clean-cart-list">
                <div className="clean-cart-header">
                  <span>Item</span>
                  <span></span>
                  <span>Price</span>
                  <span>Qty</span>
                  <span>Total</span>
                  <span></span>
                </div>

                {pricedCart.map((item) => (
                  <div className="clean-cart-row" key={item.id}>
                    <div className="clean-cart-item">
  <strong>{item.name}</strong>

  {(
  item.category === "device" ||
  item.category === "margin-vat"
) && (
    <div className="device-cart-details">
      <span>
        Guarantee:{" "}
        {item.guarantee_label ||
          item.guaranteeLabel ||
          `${
            item.guarantee_months ||
            item.guaranteeMonths
          } Month${
            Number(
              item.guarantee_months ||
                item.guaranteeMonths
            ) === 1
              ? ""
              : "s"
          }`}
      </span>
    </div>
  )}
</div>

                    <div className="clean-cart-promo">
                      {isPromoItem(item) && (
                        <small className="cart-promo-label">★ PROMO ★</small>
                      )}
                    </div>

                    <div className="clean-cart-price">
                      <span>€{Number(item.price || 0).toFixed(2)}</span>

                      {Number(item.drs_amount || 0) > 0 && (
                        <small className="cart-drs-label">
                          +DRS €{Number(item.drs_amount).toFixed(2)}
                        </small>
                      )}
                    </div>

                    <div className="clean-cart-qty">
                      <button
                        type="button"
                        disabled={saleCompleted}
                        onClick={() => decreaseQty(item.id)}
                      >
                        −
                      </button>

                      <span>{item.qty}</span>

                      <button
                        type="button"
                        disabled={saleCompleted}
                        onClick={() => increaseQty(item.id)}
                      >
                        +
                      </button>
                    </div>

                    <div className="clean-cart-total">
                      €
                      {(
                        (Number(item.price || 0) +
                          Number(item.drs_amount || 0)) *
                        Number(item.qty || 0)
                      ).toFixed(2)}
                    </div>

                    <button
                      type="button"
                      className="clean-remove-btn"
                      disabled={saleCompleted}
                      onClick={() => removeItem(item.id)}
                    >
                      X
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="clean-total-panel">
            <div className="clean-total-left">
              <span>TOTAL</span>

              <h2>€{total.toFixed(2)}</h2>

              {holdMessage?.type === "CHANGE" && (
                <div className="change-under-total">
                  Change: €{holdMessage.value.toFixed(2)}
                </div>
              )}

              {Math.max(
                0,
                total - Number(cashPaid || 0) - Number(cardPaid || 0),
              ) > 0 && (
                <div className="to-pay-under-total">
                  To Pay: €
                  {Math.max(
                    0,
                    total - Number(cashPaid || 0) - Number(cardPaid || 0),
                  ).toFixed(2)}
                </div>
              )}
            </div>

            <div className="clean-total-right">
             <div>
  <span>Subtotal</span>
  <strong>€{originalSubtotal.toFixed(2)}</strong>
</div>

{multiBuySaving > 0 && (
  <div className="multi-buy-saving-row">
    <span>Multi-Buy Saving</span>
    <strong>-€{multiBuySaving.toFixed(2)}</strong>
  </div>
)}

<div>
  <span>Cash Paid</span>
  <strong>€{Number(cashPaid || 0).toFixed(2)}</strong>
</div>

              <div>
                <span>Card Paid</span>
                <strong>€{Number(cardPaid || 0).toFixed(2)}</strong>
              </div>

              <div>
                <span>Total Items</span>
                <strong>
                  {cart.reduce((sum, item) => sum + Number(item.qty || 0), 0)}
                </strong>
              </div>
            </div>
          </div>

          <div className="cash-buttons">
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(0.05)}
            >
              5c
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(0.1)}
            >
              10c
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(0.2)}
            >
              20c
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(0.5)}
            >
              50c
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(1)}
            >
              €1
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(2)}
            >
              €2
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(5)}
            >
              €5
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(10)}
            >
              €10
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(20)}
            >
              €20
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(50)}
            >
              €50
            </button>
            <button
              disabled={saleCompleted}
              onClick={() => handleCashButton(100)}
            >
              €100
            </button>
          </div>

          <div className="buttons">
            {total < 0 ? (
              <div className="refund-payment-actions">
                <button
                  type="button"
                  className="cash-btn refund-cash-btn"
                  disabled={cart.length === 0 || saleCompleted}
                  onClick={() => checkout({ cash: Math.abs(total), card: 0 })}
                >
                  Cash €{Math.abs(total).toFixed(2)}
                </button>

                <button
                  type="button"
                  className="card-btn refund-card-btn"
                  disabled={cart.length === 0 || saleCompleted}
                  onClick={() => checkout({ cash: 0, card: Math.abs(total) })}
                >
                  Card €{Math.abs(total).toFixed(2)}
                </button>
              </div>
            ) : (
              <>
                <button
                  className="cash-btn"
                  disabled={cart.length === 0 || saleCompleted}
                  onClick={() => handleCashButton(total - cardPaid)}
                >
                  Cash
                </button>

                <button
                  className="card-btn"
                  disabled={cart.length === 0 || saleCompleted}
                  onClick={() => handleCardButton(total - cashPaid)}
                >
                  Card
                </button>
              </>
            )}
          </div>

          {manualMode && (
            <div className="manual-modal-overlay">
              <div className="manual-modal">
                <h3 className="manual-modal-title">
                  {/*  {manualMode === "grocery" && "Grocery (Non-VAT)"}
                  {manualMode === "grocery-vat" && "Grocery VAT"} */}
                  {manualMode === "grocery" && "Item (Non-VAT)"}
                  {manualMode === "grocery-vat" && "Item (23% VAT)"}
                  {manualMode === "payzone" && "Payzone (0% VAT)"}
                  {manualMode === "lotto" && "Lottery / Scratch Card (0% VAT)"}
                  {manualMode === "prize" && "Lottery Prize Paid"}
                  {manualMode === "news-magz" && "News / Magz"}
                  {manualMode === "vape" && "Vape Sale (23% VAT)"}
                  {manualMode === "nicotine-pouch" &&
                    "Nicotine Pouch Sale (23% VAT)"}
                  {manualMode === "e-liquid" && "E-Liquid Sale (23% VAT)"}
                  {manualMode === "vape-accessories" &&
                    "Vape Accessories Sale (23% VAT)"}
                  {manualMode === "pods" && "Pods Sale (23% VAT)"}
                  {manualMode === "phone-accessories" &&
                    "Phone Accessories Sale (23% VAT)"}
                  {manualMode === "print-scan-service" &&
                    "Print / Scan Service (23% VAT)"}
                  {manualMode === "repair-service" &&
                    "Repair Service (13.5% VAT)"}
                </h3>

                <div className="manual-price-display">
                  €{manualPrice || "0.00"}
                </div>

                <div className="manual-keypad">
                  <button onClick={() => pressKey("1")}>1</button>
                  <button onClick={() => pressKey("2")}>2</button>
                  <button onClick={() => pressKey("3")}>3</button>
                  <button onClick={() => pressKey("4")}>4</button>
                  <button onClick={() => pressKey("5")}>5</button>
                  <button onClick={() => pressKey("6")}>6</button>
                  <button onClick={() => pressKey("7")}>7</button>
                  <button onClick={() => pressKey("8")}>8</button>
                  <button onClick={() => pressKey("9")}>9</button>

                  <button
                    className="decimal-key"
                    onClick={() => {
                      if (!manualPrice.includes(".")) {
                        pressKey(".");
                      }
                    }}
                  >
                    .
                  </button>

                  <button onClick={() => pressKey("0")}>0</button>

                  <button
                    className="backspace-key"
                    onClick={() => {
                      setManualPrice((prev) => prev.slice(0, -1));
                    }}
                  >
                    ⌫
                  </button>

                  <button className="clear-key" onClick={clearKey}>
                    Clear
                  </button>

                  <button className="ok-key" onClick={addManualItem}>
                    OK
                  </button>
                </div>

                <button
                  className="manual-cancel-btn"
                  onClick={() => {
                    setManualMode(null);
                    setManualPrice("");
                    focusScanner();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="right-panel">
          <button className="side-btn cancel-btn" onClick={resetSale}>
            Cancel Sale
          </button>

          {/*   <button className="pos-btn eod-btn" onClick={downloadEndOfDayReport}>
            End Of Day Report
          </button> */}

          <button
            className="pos-btn zreport-btn"
            onClick={() => setShowZConfirm(true)}
          >
            Close Day (Z Report)
          </button>

          <button className="pos-btn eod-btn" onClick={handleLogout}>
            Logout
          </button>

          <button
  className="pos-btn eod-btn"
  onClick={() => {
    setInquiryMode(true);
    setInquiryItem(null);
    setBarcode("");
    setError("");
    setHoldMessage(null);

    focusScanner();
  }}
>
  INQ
</button>

          <button
            type="button"
            className={`pos-side-btn refund-mode-btn ${refundMode ? "active" : ""}`}
            onClick={() => {
              setRefundMode(true);
              setHoldMessage(null);
              setError("");
              focusScanner();
            }}
          >
            {refundMode ? "REFUND ON" : "Refund Item"}
          </button>

          <button
            type="button"
            className={`pos-side-btn clr-btn ${
              refundMode || inquiryMode ? "refund-clear-active" : ""
            }`}
            onClick={handleClrButton}
          >
            CLR
          </button>

          {isButtonEnabled("surcharge") && (
            <button className="surcharge-btn" onClick={addSurcharge}>
              Surcharge
            </button>
          )}

          {isButtonEnabled("vape") && (
            <button
              className="pos-side-btn vape-sale-btn"
              onClick={openVapeManualMode}
            >
              Vape
            </button>
          )}

          {isButtonEnabled("nicotinePouch") && (
            <button
              className="pos-side-btn nicotine-pouch-sale-btn"
              onClick={openNicotinePouchManualMode}
            >
              Nicotine Pouch
            </button>
          )}

          {isButtonEnabled("eLiquid") && (
            <button
              className="pos-side-btn liquid-sale-btn"
              onClick={openLiquidManualMode}
            >
              E-Liquid
            </button>
          )}

          {isButtonEnabled("vapeAccessories") && (
            <button
              className="pos-side-btn vape-accessories-sale-btn"
              onClick={openVapeAccessoriesManualMode}
            >
              Vape Accessories
            </button>
          )}

          {isButtonEnabled("pods") && (
            <button
              className="pos-side-btn pods-sale-btn"
              onClick={openPodsManualMode}
            >
              Pods
            </button>
          )}

          {isButtonEnabled("phoneAccessories") && (
            <button
              className="pos-side-btn phone-accessories-sale-btn"
              onClick={openPhoneAccessoriesManualMode}
            >
              Phone Accessories
            </button>
          )}

          {isButtonEnabled("device") && (
            <button
              type="button"
              className="pos-side-btn device-sale-btn"
              onClick={openDeviceSale}
            >
              Device
            </button>
          )}

          {isButtonEnabled("marginVat") && (
  <button
    type="button"
    className="pos-side-btn margin-vat-sale-btn"
    onClick={openMarginVatSale}
  >
    Margin VAT
  </button>
)}

          {isButtonEnabled("printScan") && (
            <button
              className="pos-side-btn print-scan-service-btn"
              onClick={openPrintScanServiceManualMode}
            >
              Print / Scan
            </button>
          )}

{isButtonEnabled("repairManagement") && (
  <button
    type="button"
    className="repair-management-module-btn"
    onClick={() => navigate("/repairs")}
  >
    Repair Management
  </button>
)}

          {isButtonEnabled("repairService") && (
            <button
              className="repair-service-sale-btn"
              onClick={openRepairServiceManualMode}
            >
              Repair Service
            </button>
          )}
        </div>

        {inquiryMode && inquiryItem && (
          <div className="inq-overlay">
            <div className="inq-box">
              <h1 className="inq-title">{inquiryItem.name}</h1>

              <h2 className="inq-price">
                €{Number(inquiryItem.price).toFixed(2)}
              </h2>

              <div className="inq-buttons">
                <button
                  className="inq-add"
                  onClick={() => {
                    if (saleCompleted) {
                      setCart([]);
                      setCashPaid(0);
                      setCardPaid(0);
                      setHoldMessage(null);
                      setError("");
                      setSaleCompleted(false);
                      resetAgeCheckForNewSale();
                    }

                    setCart((prev) => {
                      const existing = prev.find(
                        (item) => String(item.id) === String(inquiryItem.id),
                      );

                      if (existing) {
                        return prev.map((item) =>
                          String(item.id) === String(inquiryItem.id)
                            ? {
                                ...item,
                                qty: Number(item.qty || 0) + 1,
                              }
                            : item,
                        );
                      }

                      return [
                        ...prev,
                        {
                          ...inquiryItem,
                          qty: 1,
                          category: inquiryItem.category || "uncategorized",
                          vat_code: inquiryItem.vat_code || "A",
                          container_size_ml:
                            inquiryItem.container_size_ml || null,
                          is_drs: inquiryItem.is_drs || false,
                          drs_amount: Number(inquiryItem.drs_amount || 0),
                        },
                      ];
                    });

                    setInquiryMode(false);
                    setInquiryItem(null);
                    setBarcode("");
                    setError("");
                    focusScanner();
                  }}
                >
                  ADD TO CART
                </button>

                <button
                  className="inq-close"
                  onClick={() => {
                    setInquiryMode(false);
                    setInquiryItem(null);
                    setBarcode("");
                    focusScanner();
                  }}
                >
                  CLOSE
                </button>
              </div>
            </div>
          </div>
        )}

        {showZConfirm && (
          <div className="confirm-overlay">
            <div className="confirm-box">
              <h3>End of Day Report</h3>

              <p>
                Are you sure you want to close the day?
                <br />
                This will lock all sales for today.
              </p>

              <div className="confirm-actions">
                <button onClick={() => setShowZConfirm(false)}>Cancel</button>

                <button
                  className="danger"
                  onClick={async () => {
                    setShowZConfirm(false);
                    await closeDay();
                  }}
                >
                  Confirm Close Day
                </button>
              </div>
            </div>
          </div>
        )}

        {agePromptProduct && (
          <div className="age-check-overlay">
            <div className="age-check-popup">
              <div className="age-check-badge">18+</div>

              <h2>Age Verification Required</h2>

              <p className="age-check-product">{agePromptProduct.name}</p>

              <p className="age-check-message">
                This is an age restricted product. Please confirm the customer
                is over 18 before continuing the sale.
              </p>

              <div className="age-check-actions">
                <button
                  type="button"
                  className="age-check-refuse"
                  onClick={refuseAgeCheck}
                >
                  Refuse Sale
                </button>

                <button
                  type="button"
                  className="age-check-approve"
                  onClick={approveAgeCheck}
                >
                  Customer is Over 18
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default POSPage;